import appSettings from "../settings/appSettings";
import fetchRequest from "../services/fetchRequest";
import { ChildData } from "../types";
import { wvusLogger } from "../helpers";
const { requestRCDSConfig } = appSettings;

export async function getRandomChild() {
  const baseUrl = requestRCDSConfig.baseURL;
  const endpoint = requestRCDSConfig.endpoints.random_search_get;
  const requestUrl = `${baseUrl}${endpoint}`;
  const apiKey = requestRCDSConfig.apiKey;

  try {
    const resp = await fetchRequest(requestUrl, {
      method: "POST",
      timeout: 10000,
      headers: {
        accept: "application/json, text/plain, */*",
        "content-type": "application/json",
        "ocp-apim-subscription-key": apiKey
      },
      body: JSON.stringify({
        searchCriteriaList: [
          {
            minimumAge: "",
            maximumAge: "",
            countryCodes: [],
            gender: "",
            orphan: 0,
            disabledFlag: 0,
            minimumDaysAwaitingSponsorshipCount: ""
          }
        ],
        sortOrder: 0,
        take: 5
      })
    });

    if (!resp.ok) {
      return resp
        .text()
        .then(parseJson)
        .then((respData) => {
          throw new Error(
            respData?.Message || respData?.message || respData || "Error fetching child data"
          );
        });
    }

    const respData = await resp.json();

    const childrenData = respData?.data?.items || [];

    // TODO: Check Data
    // childrenData
    const [childData] = childrenData || [];

    return childData;
  } catch (error) {
    wvusLogger.log(
      new Error(`Error Response from RCDS for get Random Child:  ${error}`),
      wvusLogger.getLogLevelNames().ERROR
    );
    return Promise.reject(error);
  }
}

export async function getChildByGuid(guid: string) {
  const baseUrl = requestRCDSConfig.baseURL;
  const endpoint = requestRCDSConfig.endpoints.child_detail_get;
  const requestUrl = `${baseUrl}${endpoint}`.replace("{identifier}", guid);
  const apiKey = requestRCDSConfig.apiKey;

  // const apiKey = `0c552981569e4e388128676547f43933`;
  // const requestUrl = `https://wv-rcds-uat-api.azure-api.net/v3/api/Sponsorship/children/${guid}/web?subscription-key=${apiKey}`;

  try {
    const resp = await fetchRequest(requestUrl, {
      method: "GET",
      timeout: 10000,
      headers: {
        accept: "application/json, text/plain, */*",
        "content-type": "application/json",
        "ocp-apim-subscription-key": apiKey
      }
    });

    if (!resp.ok) {
      return resp
        .text()
        .then(parseJson)
        .then((respData) => {
          throw new Error(
            respData?.Message || respData?.message || respData || "Error fetching child data"
          );
        });
    }

    const respData = await resp.json();

    const childData = transformChildData(respData.data);

    return childData;
  } catch (error) {
    wvusLogger.log(
      new Error(`Error Response from RCDS for get child by GUID:  ${error}`),
      wvusLogger.getLogLevelNames().ERROR
    );
    return Promise.reject(error);
  }
}

export const parseJson = (text: string) => {
  try {
    return JSON.parse(text);
  } catch (error) {
    if (text.length === 264) {
      return "Invalid response data";
    }
    return text;
  }
};

export function checkIsChildAvailable(childData: ChildData) {
  const isAvailable = childData.availableFlag === true;
  const notSponsored = childData.sponsoredFlag !== true;
  const notLocked = !childData.lockIdentifier;

  return isAvailable && notSponsored && notLocked;
}

export function transformChildData(childData) {
  const parseMedia = parseChildMedia(childData);

  return {
    ...childData,
    ...parseMedia
  };
}

export function parseChildMedia(childData) {
  const filterCriteria = {
    cgpUrl: {
      contentTypeCode: "CGP",
      format: "web"
    },
    cgpThumbnailUrl: {
      contentTypeCode: "CGP",
      format: "thumb"
    },
    cgvWebUrl: {
      contentTypeCode: "CGV",
      format: "web"
    },
    cgViPadUrl: {
      contentTypeCode: "CGV",
      format: "ipad"
    }
  };

  // sort childMedia by mediaData descending (newest first)
  const sortedMedia = childData?.childMedia?.toSorted((a, b) => {
    const dateA = new Date(a.mediaDate).getTime();
    const dateB = new Date(b.mediaDate).getTime();
    return dateB - dateA;
  });

  const parsedMedia = sortedMedia?.reduce(
    (data, media) => {
      const criterialist = Object.entries(filterCriteria);
      const hasAllCriteria = criterialist.every(([key]) => data[key]);

      if (hasAllCriteria) {
        return data;
      }

      for (const [key, criteria] of criterialist) {
        // For CGP photos, only use standard portraits (empty subtypeCode)
        // This excludes "Friends or Family" (ST097) and other subtypes
        const isCGP = criteria.contentTypeCode === "CGP";
        const hasSubtype = media.subtypeCode && media.subtypeCode.trim() !== "";
        if (isCGP && hasSubtype) {
          continue;
        }

        if (
          !data[key] &&
          media.contentTypeCode === criteria.contentTypeCode &&
          media.format === criteria.format
        ) {
          data[key] = media.url;
          break;
        }
      }

      return data;
    },
    {
      cgpUrl: null,
      cgpThumbnailUrl: null,
      cgvWebUrl: null,
      cgViPadUrl: null
    }
  );

  return parsedMedia;
}

export async function getMockRandomChild(/* searchCriteria = {} */) {
  await new Promise((resolve) => setTimeout(resolve, 1000));
  return {
    identifier: "015d5bd7-b63b-4870-ba3c-c573950c9af2",
    supportOfficeChildId: "185551-8920",
    givenName: "Mihiret",
    familyName: null,
    gender: "Female",
    birthdate: "2011-11-03T00:00:00",
    age: 12,
    disabledFlag: false,
    orphanFlag: false,
    daysAwaitingSponsorshipCount: 595,
    availableFlag: true,
    inProgramFlag: true,
    passedDataQualityCheckFlag: true,
    sponsoredFlag: false,
    reservationIdentifier: null,
    reservationBatchNumber: null,
    reservationPurpose: null,
    reservationReferenceIdentifier: null,
    reservationExpirationDate: null,
    reservationChannelCode: null,
    reservationChannelDescription: null,
    lockIdentifier: null,
    lockExpirationDate: null,
    favoriteGameCode: "10",
    favoriteGameDescription: "Hide and seek",
    livesWithCode: "1",
    livesWithDescription: "Parents",
    languageCode: "12412",
    languageDescription: "Oromo, Borana-Arusi-Guji",
    highestGrade: 1,
    highestEducationLevel: null,
    favoriteSubjectCode: "2",
    favoriteSubjectDescription: "Drawing",
    cgpUrl: "https://d4j0oemdjsbb4.cloudfront.net/child/images/185551-XYRP_20220413_132819_CGP.jpg",
    cgpThumbnailUrl:
      "https://d4j0oemdjsbb4.cloudfront.net/child/images/185551-XYRP_20220413_132819_CGP_thumb.jpg",
    cgvWebUrl:
      "https://d4j0oemdjsbb4.cloudfront.net/child/video/185551-XYRP_20220413_132843_CGV_Web.mp4",
    cgViPadUrl:
      "https://d4j0oemdjsbb4.cloudfront.net/child/video/185551-XYRP_20220413_132843_CGV_iPad.mp4",
    cgvMobileUrl: null,
    regionIdentifier: "AFE",
    regionName: "East Africa",
    countryCode: "ETH",
    countryName: "Ethiopia",
    projectIdentifier: "185551",
    projectName: "Abaya Adp Progr. & Sponsorship Management Project",
    webPublishableFlag: true,
    webPublishableRestrictionsFlag: false,
    christianWitnessSensitivityCode: 2,
    christianWitnessSensitivityDescription: "Sensitive",
    story: [
      "Mihiret lives with her parents and has no brothers or sisters. Her parents struggle to provide for the family. Her father is unemployed and her mother is unemployed. Despite their efforts, it is difficult to meet the family's needs.",
      "Mihiret is growing up in a poor area in Ethiopia. The HIV and AIDS crisis has severely damaged the social fabric of the entire community, leaving many children without parents. Many families live in mud huts with thatched roofs. A typical diet consists of maize, cassava, sweet potatoes, grains, and bananas. Agriculture is the primary income-generating activity; many families produce maize or coffee and raise livestock.",
      "She helps at home by being good. She likes to play hide and seek. She is in satisfactory health.",
      "Your sponsorship commitment will help provide Mihiret and her community with greater access to clean water as well as medicine, immunizations, nutrition training, and disease prevention. Your faithful support will also train teachers in improved, effective teaching methods. Farmers will learn about modern farming technologies and practices, helping them increase their production. And our caring staff will reflect Christ's love to these children through their actions and lives."
    ],
    searchCriteriaPosition: 0
  };
}

// const childrenData = await fetch("https://wv-rcds-uat-api.azure-api.net/v3/api/Sponsorship/children/search/web?subscription-key=0c552981569e4e388128676547f43933", {
//         "headers": {
//           "accept": "application/json, text/plain, */*",
//           "content-type": "application/json",
//           "ocp-apim-subscription-key": "0c552981569e4e388128676547f43933",
//         },
//         "body": "{\"searchCriteriaList\":[{\"minimumAge\":\"\",\"maximumAge\":\"\",\"countryCodes\":[],\"gender\":\"\",\"orphan\":0,\"disabledFlag\":0,\"minimumDaysAwaitingSponsorshipCount\":\"\"}],\"sortOrder\":0,\"take\":20}",
//         "method": "POST"
//       }).then((response) => response.json());

// fetch("https://wv-rcds-uat-api.azure-api.net/v3/api/Sponsorship/children/1518937a-f74e-4fb5-ac97-523f273f87d0/web?subscription-key=0c552981569e4e388128676547f43933", {
//   "headers": {
//     "accept": "application/json, text/plain, */*",
//     "accept-language": "en-US,en;q=0.9",
//     "ocp-apim-subscription-key": "0c552981569e4e388128676547f43933",
//     "sec-ch-ua": "\"Google Chrome\";v=\"119\", \"Chromium\";v=\"119\", \"Not?A_Brand\";v=\"24\"",
//     "sec-ch-ua-mobile": "?0",
//     "sec-ch-ua-platform": "\"macOS\"",
//     "sec-fetch-dest": "empty",
//     "sec-fetch-mode": "cors",
//     "sec-fetch-site": "cross-site"
//   },
//   "referrer": "https://qa.worldvision.org/",
//   "referrerPolicy": "strict-origin-when-cross-origin",
//   "body": null,
//   "method": "GET",
//   "mode": "cors",
//   "credentials": "omit"
// });

/*

{
    "data": {
        "identifier": "015d5bd7-b63b-4870-ba3c-c573950c9af2",
        "supportOfficeChildId": "185551-8920",
        "age": 12,
        "birthdate": "2011-11-03T00:00:00",
        "daysAwaitingSponsorshipCount": 596,
        "givenName": "Mihiret",
        "familyName": null,
        "gender": "Female",
        "orphanFlag": false,
        "disabledFlag": false,
        "disabilities": [],
        "availableFlag": true,
        "inProgramFlag": true,
        "passedDataQualityCheckFlag": true,
        "sponsoredFlag": false,
        "reservationIdentifier": null,
        "reservationBatchNumber": null,
        "reservationPurpose": null,
        "reservationReferenceIdentifier": null,
        "reservationExpirationDate": null,
        "reservationChannelCode": null,
        "reservationChannelDescription": null,
        "lockIdentifier": null,
        "lockExpirationDate": null,
        "languageCode": "12412",
        "languageDescription": "Oromo, Borana-Arusi-Guji",
        "highestGrade": 1,
        "highestEducationLevel": null,
        "favoriteSubjectCode": "2",
        "favoriteSubjectDescription": "Drawing",
        "reasonNotInSchoolCode": "",
        "reasonNotInSchoolDescription": null,
        "choresPerformedCode": "25",
        "choresPerformedDescription": "Doesn't help - too young",
        "hoursWorkedPerWeek": null,
        "healthStatusCode": "4",
        "healthStatusDescription": "Satisfactory",
        "favoriteGameCode": "10",
        "favoriteGameDescription": "Hide and seek",
        "regionIdentifier": "AFE",
        "regionName": "East Africa",
        "countryCode": "ETH",
        "countryName": "Ethiopia",
        "nationalOfficeCode": null,
        "nationalOfficeName": null,
        "projectIdentifier": "185551",
        "projectName": "Abaya Adp Progr. & Sponsorship Management Project",
        "webPublishableFlag": true,
        "webPublishableRestrictionsFlag": false,
        "christianWitnessSensitivityCode": 2,
        "christianWitnessSensitivityDescription": "Sensitive",
        "livesWithCode": "1",
        "livesWithDescription": "Parents",
        "brotherCount": 0,
        "sisterCount": 0,
        "motherStatusCode": "B",
        "motherStatusDescription": "Married",
        "motherEmploymentStatusCode": "3",
        "motherEmploymentStatusDescription": "Unemployed",
        "fatherStatusDescription": "Married",
        "fatherStatusCode": "B",
        "fatherEmploymentStatusCode": "3",
        "fatherEmploymentStatusDescription": "Unemployed",
        "story": [
            "Mihiret lives with her parents and has no brothers or sisters. Her parents struggle to provide for the family. Her father is unemployed and her mother is unemployed. Despite their efforts, it is difficult to meet the family's needs.",
            "Mihiret is growing up in a poor area in Ethiopia. The HIV and AIDS crisis has severely damaged the social fabric of the entire community, leaving many children without parents. Many families live in mud huts with thatched roofs. A typical diet consists of maize, cassava, sweet potatoes, grains, and bananas. Agriculture is the primary income-generating activity; many families produce maize or coffee and raise livestock.",
            "She helps at home by being good. She likes to play hide and seek. She is in satisfactory health.",
            "Your sponsorship commitment will help provide Mihiret and her community with greater access to clean water as well as medicine, immunizations, nutrition training, and disease prevention. Your faithful support will also train teachers in improved, effective teaching methods. Farmers will learn about modern farming technologies and practices, helping them increase their production. And our caring staff will reflect Christ's love to these children through their actions and lives."
        ],
        "childMedia": [
            {
                "contentTypeCode": "CGP",
                "format": "original",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": null,
                "url": "https://d3cfrqjucqh0ip.cloudfront.net/child/images/185551-XYRP_20220413_132819_CGP.jpg",
                "lastModifiedDate": "2022-04-27T04:51:09",
                "mediaDate": "2022-04-13T13:28:19"
            },
            {
                "contentTypeCode": "CGP",
                "format": "web",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": null,
                "url": "https://d4j0oemdjsbb4.cloudfront.net/child/images/185551-XYRP_20220413_132819_CGP.jpg",
                "lastModifiedDate": "2022-04-27T04:51:09",
                "mediaDate": "2022-04-13T13:28:19"
            },
            {
                "contentTypeCode": "CGP",
                "format": "thumb",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": null,
                "url": "https://d4j0oemdjsbb4.cloudfront.net/child/images/185551-XYRP_20220413_132819_CGP_thumb.jpg",
                "lastModifiedDate": "2022-04-27T04:51:09",
                "mediaDate": "2022-04-13T13:28:19"
            },
            {
                "contentTypeCode": "CGV",
                "format": "web",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": null,
                "url": "https://d4j0oemdjsbb4.cloudfront.net/child/video/185551-XYRP_20220413_132843_CGV_Web.mp4",
                "lastModifiedDate": "2022-08-23T03:10:33",
                "mediaDate": "2022-04-13T13:28:43"
            },
            {
                "contentTypeCode": "CGV",
                "format": "ipad",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": null,
                "url": "https://d4j0oemdjsbb4.cloudfront.net/child/video/185551-XYRP_20220413_132843_CGV_iPad.mp4",
                "lastModifiedDate": "2022-08-23T03:10:33",
                "mediaDate": "2022-04-13T13:28:43"
            },
            {
                "contentTypeCode": "CGV",
                "format": "vthumb",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": null,
                "url": "https://d4j0oemdjsbb4.cloudfront.net/child/images/185551-XYRP_20220413_132843_CGV_vThumb.png",
                "lastModifiedDate": "2022-08-23T03:10:33",
                "mediaDate": "2022-04-13T13:28:43"
            },
            {
                "contentTypeCode": "CGV",
                "format": "mob",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": null,
                "url": "https://d4j0oemdjsbb4.cloudfront.net/child/video/185551-XYRP_20220413_132843_CGV_Mob.mp4",
                "lastModifiedDate": "2022-08-23T03:10:33",
                "mediaDate": "2022-04-13T13:28:43"
            }
        ],
        "projectMedia": [
            {
                "contentTypeCode": "OCP",
                "format": "original",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": "Debela Obsa, member of the child parliament leader said that after the establishment of child parliament by world vision child participation has increased in matters that affect the lives of children.",
                "url": "https://d3cfrqjucqh0ip.cloudfront.net/project/images/185551_20140628_094514_OCP.JPG",
                "lastModifiedDate": "2023-01-13T07:04:10",
                "mediaDate": "2014-06-28T09:45:14"
            },
            {
                "contentTypeCode": "OCP",
                "format": "web",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": "Debela Obsa, member of the child parliament leader said that after the establishment of child parliament by world vision child participation has increased in matters that affect the lives of children.",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20140628_094514_OCP.JPG",
                "lastModifiedDate": "2023-01-13T07:04:10",
                "mediaDate": "2014-06-28T09:45:14"
            },
            {
                "contentTypeCode": "OCP",
                "format": "thumb",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": "Debela Obsa, member of the child parliament leader said that after the establishment of child parliament by world vision child participation has increased in matters that affect the lives of children.",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20140628_094514_OCP_thumb.jpg",
                "lastModifiedDate": "2023-01-13T07:04:10",
                "mediaDate": "2014-06-28T09:45:14"
            },
            {
                "contentTypeCode": "OCP",
                "format": "web",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": "Best performing children are Awarded at Hose Golla Kebele Primary School",
                "url": "http://mrs.worldvision.org/mgen/imageSize.ms?args=\"psi:/185551/185551_20130725_102746_OCP.jpg\",640,480&jp=1",
                "lastModifiedDate": "2023-01-13T07:04:10",
                "mediaDate": "2013-07-25T10:27:46"
            },
            {
                "contentTypeCode": "OCP",
                "format": "thumb",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": "Best performing children are Awarded at Hose Golla Kebele Primary School",
                "url": "http://mrs.worldvision.org/mgen/imageSize.ms?args=\"psi:/185551/185551_20130725_102746_OCP_thumb.jpg\",150,112&jp=1",
                "lastModifiedDate": "2023-01-13T07:04:10",
                "mediaDate": "2013-07-25T10:27:46"
            },
            {
                "contentTypeCode": "OCP",
                "format": "original",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": "Best performing children are Awarded at Hose Golla Kebele Primary School",
                "url": "http://mrs.worldvision.org/mgen/psi:/185551/185551_20130725_102746_OCP.jpg",
                "lastModifiedDate": "2023-01-13T07:04:10",
                "mediaDate": "2013-07-25T10:27:46"
            },
            {
                "contentTypeCode": "OCP",
                "format": "web",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": "\"We are enjoying in the newly constructed child center by World Vision,\" said one child. ",
                "url": "http://mrs.worldvision.org/mgen/imageSize.ms?args=\"psi:/185551/185551_20120810_153016_OCP.jpg\",640,480&jp=1",
                "lastModifiedDate": "2023-01-13T07:04:10",
                "mediaDate": "2012-08-10T15:30:16"
            },
            {
                "contentTypeCode": "OCP",
                "format": "thumb",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": "\"We are enjoying in the newly constructed child center by World Vision,\" said one child. ",
                "url": "http://mrs.worldvision.org/mgen/imageSize.ms?args=\"psi:/185551/185551_20120810_153016_OCP_thumb.jpg\",150,112&jp=1",
                "lastModifiedDate": "2023-01-13T07:04:10",
                "mediaDate": "2012-08-10T15:30:16"
            },
            {
                "contentTypeCode": "OCP",
                "format": "original",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": "\"We are enjoying in the newly constructed child center by World Vision,\" said one child. ",
                "url": "http://mrs.worldvision.org/mgen/psi:/185551/185551_20120810_153016_OCP.jpg",
                "lastModifiedDate": "2023-01-13T07:04:10",
                "mediaDate": "2012-08-10T15:30:16"
            },
            {
                "contentTypeCode": "OCP",
                "format": "web",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": "\"We were suffering from waterborne disease. The construction of water point by World Vision has improved our health situation. Besides, it has decreased the distance that we were traveling on foot,\" said a member of the community.",
                "url": "http://mrs.worldvision.org/mgen/imageSize.ms?args=\"psi:/185551/185551_20120810_152848_OCP.jpg\",640,480&jp=1",
                "lastModifiedDate": "2023-01-13T07:04:10",
                "mediaDate": "2012-08-10T15:28:48"
            },
            {
                "contentTypeCode": "OCP",
                "format": "thumb",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": "\"We were suffering from waterborne disease. The construction of water point by World Vision has improved our health situation. Besides, it has decreased the distance that we were traveling on foot,\" said a member of the community.",
                "url": "http://mrs.worldvision.org/mgen/imageSize.ms?args=\"psi:/185551/185551_20120810_152848_OCP_thumb.jpg\",150,112&jp=1",
                "lastModifiedDate": "2023-01-13T07:04:10",
                "mediaDate": "2012-08-10T15:28:48"
            },
            {
                "contentTypeCode": "OCP",
                "format": "original",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": "\"We were suffering from waterborne disease. The construction of water point by World Vision has improved our health situation. Besides, it has decreased the distance that we were traveling on foot,\" said a member of the community.",
                "url": "http://mrs.worldvision.org/mgen/psi:/185551/185551_20120810_152848_OCP.jpg",
                "lastModifiedDate": "2023-01-13T07:04:10",
                "mediaDate": "2012-08-10T15:28:48"
            },
            {
                "contentTypeCode": "OCP",
                "format": "web",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": "\"We were suffering from waterborne disease. The construction of water point by World Vision has improved our health situation. Besides, it has decreased the distance that we were traveling on foot,\" said Tamirayehu, who is 19 years old.",
                "url": "http://mrs.worldvision.org/mgen/imageSize.ms?args=\"psi:/185551/185551_20120810_152812_OCP.jpg\",640,480&jp=1",
                "lastModifiedDate": "2023-01-13T07:04:10",
                "mediaDate": "2012-08-10T15:28:12"
            },
            {
                "contentTypeCode": "OCP",
                "format": "thumb",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": "\"We were suffering from waterborne disease. The construction of water point by World Vision has improved our health situation. Besides, it has decreased the distance that we were traveling on foot,\" said Tamirayehu, who is 19 years old.",
                "url": "http://mrs.worldvision.org/mgen/imageSize.ms?args=\"psi:/185551/185551_20120810_152812_OCP_thumb.jpg\",150,112&jp=1",
                "lastModifiedDate": "2023-01-13T07:04:10",
                "mediaDate": "2012-08-10T15:28:12"
            },
            {
                "contentTypeCode": "OCP",
                "format": "original",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": "\"We were suffering from waterborne disease. The construction of water point by World Vision has improved our health situation. Besides, it has decreased the distance that we were traveling on foot,\" said Tamirayehu, who is 19 years old.",
                "url": "http://mrs.worldvision.org/mgen/psi:/185551/185551_20120810_152812_OCP.jpg",
                "lastModifiedDate": "2023-01-13T07:04:10",
                "mediaDate": "2012-08-10T15:28:12"
            },
            {
                "contentTypeCode": "OCP",
                "format": "web",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": "\"We are glad to see this water reservoir in our community built by World Vision. It has increased access to potable water supply,\" said Mamo, the village leader.",
                "url": "http://mrs.worldvision.org/mgen/imageSize.ms?args=\"psi:/185551/185551_20120810_152730_OCP.jpg\",640,480&jp=1",
                "lastModifiedDate": "2023-01-13T07:04:10",
                "mediaDate": "2012-08-10T15:27:30"
            },
            {
                "contentTypeCode": "OCP",
                "format": "thumb",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": "\"We are glad to see this water reservoir in our community built by World Vision. It has increased access to potable water supply,\" said Mamo, the village leader.",
                "url": "http://mrs.worldvision.org/mgen/imageSize.ms?args=\"psi:/185551/185551_20120810_152730_OCP_thumb.jpg\",150,112&jp=1",
                "lastModifiedDate": "2023-01-13T07:04:10",
                "mediaDate": "2012-08-10T15:27:30"
            },
            {
                "contentTypeCode": "OCP",
                "format": "original",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": "\"We are glad to see this water reservoir in our community built by World Vision. It has increased access to potable water supply,\" said Mamo, the village leader.",
                "url": "http://mrs.worldvision.org/mgen/psi:/185551/185551_20120810_152730_OCP.jpg",
                "lastModifiedDate": "2023-01-13T07:04:10",
                "mediaDate": "2012-08-10T15:27:30"
            },
            {
                "contentTypeCode": "OCP",
                "format": "web",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": "One of the beneficiaries, Solomon, said, \"The provision of improved milk-yielding heifer by World Vision has increased [the] number of households having improved livestock.\"",
                "url": "http://mrs.worldvision.org/mgen/imageSize.ms?args=\"psi:/185551/185551_20120810_152622_OCP.jpg\",640,480&jp=1",
                "lastModifiedDate": "2023-01-13T07:04:10",
                "mediaDate": "2012-08-10T15:26:22"
            },
            {
                "contentTypeCode": "OCP",
                "format": "thumb",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": "One of the beneficiaries, Solomon, said, \"The provision of improved milk-yielding heifer by World Vision has increased [the] number of households having improved livestock.\"",
                "url": "http://mrs.worldvision.org/mgen/imageSize.ms?args=\"psi:/185551/185551_20120810_152622_OCP_thumb.jpg\",150,112&jp=1",
                "lastModifiedDate": "2023-01-13T07:04:10",
                "mediaDate": "2012-08-10T15:26:22"
            },
            {
                "contentTypeCode": "OCP",
                "format": "original",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": "One of the beneficiaries, Solomon, said, \"The provision of improved milk-yielding heifer by World Vision has increased [the] number of households having improved livestock.\"",
                "url": "http://mrs.worldvision.org/mgen/psi:/185551/185551_20120810_152622_OCP.jpg",
                "lastModifiedDate": "2023-01-13T07:04:10",
                "mediaDate": "2012-08-10T15:26:22"
            },
            {
                "contentTypeCode": "OCP",
                "format": "web",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": "\"The previous classroom has no door and windows. It was also constructed with wood and mud. We are now very happy due to the newly constructed classrooms by World Vision. It has significantly improved the teaching-learning process,\" said the school director, Yisihak.",
                "url": "http://mrs.worldvision.org/mgen/imageSize.ms?args=\"psi:/185551/185551_20120810_152518_OCP.jpg\",640,480&jp=1",
                "lastModifiedDate": "2023-01-13T07:04:10",
                "mediaDate": "2012-08-10T15:25:18"
            },
            {
                "contentTypeCode": "OCP",
                "format": "thumb",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": "\"The previous classroom has no door and windows. It was also constructed with wood and mud. We are now very happy due to the newly constructed classrooms by World Vision. It has significantly improved the teaching-learning process,\" said the school director, Yisihak.",
                "url": "http://mrs.worldvision.org/mgen/imageSize.ms?args=\"psi:/185551/185551_20120810_152518_OCP_thumb.jpg\",150,112&jp=1",
                "lastModifiedDate": "2023-01-13T07:04:10",
                "mediaDate": "2012-08-10T15:25:18"
            },
            {
                "contentTypeCode": "OCP",
                "format": "original",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": "\"The previous classroom has no door and windows. It was also constructed with wood and mud. We are now very happy due to the newly constructed classrooms by World Vision. It has significantly improved the teaching-learning process,\" said the school director, Yisihak.",
                "url": "http://mrs.worldvision.org/mgen/psi:/185551/185551_20120810_152518_OCP.jpg",
                "lastModifiedDate": "2023-01-13T07:04:10",
                "mediaDate": "2012-08-10T15:25:18"
            },
            {
                "contentTypeCode": "OCP",
                "format": "web",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": "Families in the Abaya community receive livestock as part of World Vision’s agricultural support. ",
                "url": "http://mrs.worldvision.org/mgen/imageSize.ms?args=\"psi:/185551/185551_20110402_161532_OCP.jpg\",640,480&jp=1",
                "lastModifiedDate": "2023-01-13T07:04:10",
                "mediaDate": "2011-04-02T16:15:32"
            },
            {
                "contentTypeCode": "OCP",
                "format": "thumb",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": "Families in the Abaya community receive livestock as part of World Vision’s agricultural support. ",
                "url": "http://mrs.worldvision.org/mgen/imageSize.ms?args=\"psi:/185551/185551_20110402_161532_OCP_thumb.jpg\",150,112&jp=1",
                "lastModifiedDate": "2023-01-13T07:04:10",
                "mediaDate": "2011-04-02T16:15:32"
            },
            {
                "contentTypeCode": "OCP",
                "format": "original",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": "Families in the Abaya community receive livestock as part of World Vision’s agricultural support. ",
                "url": "http://mrs.worldvision.org/mgen/psi:/185551/185551_20110402_161532_OCP.jpg",
                "lastModifiedDate": "2023-01-13T07:04:10",
                "mediaDate": "2011-04-02T16:15:32"
            },
            {
                "contentTypeCode": "OCP",
                "format": "web",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": "World Vision organizes extracurricular activities like soccer to encourage children to stay in school.",
                "url": "http://mrs.worldvision.org/mgen/imageSize.ms?args=\"psi:/185551/185551_20110402_161448_OCP.jpg\",640,480&jp=1",
                "lastModifiedDate": "2023-01-13T07:04:10",
                "mediaDate": "2011-04-02T16:14:48"
            },
            {
                "contentTypeCode": "OCP",
                "format": "thumb",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": "World Vision organizes extracurricular activities like soccer to encourage children to stay in school.",
                "url": "http://mrs.worldvision.org/mgen/imageSize.ms?args=\"psi:/185551/185551_20110402_161448_OCP_thumb.jpg\",150,112&jp=1",
                "lastModifiedDate": "2023-01-13T07:04:10",
                "mediaDate": "2011-04-02T16:14:48"
            },
            {
                "contentTypeCode": "OCP",
                "format": "original",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": "World Vision organizes extracurricular activities like soccer to encourage children to stay in school.",
                "url": "http://mrs.worldvision.org/mgen/psi:/185551/185551_20110402_161448_OCP.jpg",
                "lastModifiedDate": "2023-01-13T07:04:10",
                "mediaDate": "2011-04-02T16:14:48"
            },
            {
                "contentTypeCode": "OCP",
                "format": "web",
                "subtypeCode": "ST547",
                "subtypeDescription": "Education",
                "captionForSupporter": "AtoBereketBedhaso, the vice principal of the school, said that, \"Currently, thanks to world vision Ethiopia Abaya area development program; Students are now sitting in clean class rooms that are appetizing for active learning. Our school became school of choice and other neighboring village communit",
                "url": "http://mrs.worldvision.org/mgen/imageSize.ms?args=\"psi:/185551/185551_20130809_160740_OCP.jpg\",640,480&jp=1",
                "lastModifiedDate": "2023-01-13T07:04:10",
                "mediaDate": "2013-08-09T16:07:40"
            },
            {
                "contentTypeCode": "OCP",
                "format": "thumb",
                "subtypeCode": "ST547",
                "subtypeDescription": "Education",
                "captionForSupporter": "AtoBereketBedhaso, the vice principal of the school, said that, \"Currently, thanks to world vision Ethiopia Abaya area development program; Students are now sitting in clean class rooms that are appetizing for active learning. Our school became school of choice and other neighboring village communit",
                "url": "http://mrs.worldvision.org/mgen/imageSize.ms?args=\"psi:/185551/185551_20130809_160740_OCP_thumb.jpg\",150,112&jp=1",
                "lastModifiedDate": "2023-01-13T07:04:10",
                "mediaDate": "2013-08-09T16:07:40"
            },
            {
                "contentTypeCode": "OCP",
                "format": "original",
                "subtypeCode": "ST547",
                "subtypeDescription": "Education",
                "captionForSupporter": "AtoBereketBedhaso, the vice principal of the school, said that, \"Currently, thanks to world vision Ethiopia Abaya area development program; Students are now sitting in clean class rooms that are appetizing for active learning. Our school became school of choice and other neighboring village communit",
                "url": "http://mrs.worldvision.org/mgen/psi:/185551/185551_20130809_160740_OCP.jpg",
                "lastModifiedDate": "2023-01-13T07:04:10",
                "mediaDate": "2013-08-09T16:07:40"
            },
            {
                "contentTypeCode": "OCP",
                "format": "original",
                "subtypeCode": "ST548",
                "subtypeDescription": "Health",
                "captionForSupporter": "The Guangua health center official said that infant and maternal mortality has reduced significantly due to an awarness raising activity conducted by world vision",
                "url": "https://d3cfrqjucqh0ip.cloudfront.net/project/images/185551_20140628_094606_OCP.JPG",
                "lastModifiedDate": "2023-01-13T07:04:10",
                "mediaDate": "2014-06-28T09:46:06"
            },
            {
                "contentTypeCode": "OCP",
                "format": "web",
                "subtypeCode": "ST548",
                "subtypeDescription": "Health",
                "captionForSupporter": "The Guangua health center official said that infant and maternal mortality has reduced significantly due to an awarness raising activity conducted by world vision",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20140628_094606_OCP.JPG",
                "lastModifiedDate": "2023-01-13T07:04:10",
                "mediaDate": "2014-06-28T09:46:06"
            },
            {
                "contentTypeCode": "OCP",
                "format": "thumb",
                "subtypeCode": "ST548",
                "subtypeDescription": "Health",
                "captionForSupporter": "The Guangua health center official said that infant and maternal mortality has reduced significantly due to an awarness raising activity conducted by world vision",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20140628_094606_OCP_thumb.jpg",
                "lastModifiedDate": "2023-01-13T07:04:10",
                "mediaDate": "2014-06-28T09:46:06"
            },
            {
                "contentTypeCode": "OCP",
                "format": "original",
                "subtypeCode": "ST549",
                "subtypeDescription": "Livelihood",
                "captionForSupporter": "A farmer from Semero village said that the provision of selected maize seed variety and the training provided by world vision has contributed to raise maize productivity. ",
                "url": "https://d3cfrqjucqh0ip.cloudfront.net/project/images/185551_20130809_162015_OCP.JPG",
                "lastModifiedDate": "2023-01-13T07:04:10",
                "mediaDate": "2013-08-09T16:20:15"
            },
            {
                "contentTypeCode": "OCP",
                "format": "web",
                "subtypeCode": "ST549",
                "subtypeDescription": "Livelihood",
                "captionForSupporter": "A farmer from Semero village said that the provision of selected maize seed variety and the training provided by world vision has contributed to raise maize productivity. ",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20130809_162015_OCP.JPG",
                "lastModifiedDate": "2023-01-13T07:04:10",
                "mediaDate": "2013-08-09T16:20:15"
            },
            {
                "contentTypeCode": "OCP",
                "format": "thumb",
                "subtypeCode": "ST549",
                "subtypeDescription": "Livelihood",
                "captionForSupporter": "A farmer from Semero village said that the provision of selected maize seed variety and the training provided by world vision has contributed to raise maize productivity. ",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20130809_162015_OCP_thumb.jpg",
                "lastModifiedDate": "2023-01-13T07:04:10",
                "mediaDate": "2013-08-09T16:20:15"
            },
            {
                "contentTypeCode": "OCP",
                "format": "web",
                "subtypeCode": "ST549",
                "subtypeDescription": "Livelihood",
                "captionForSupporter": "The newly constructed cattle crash by world vision Ethiopia Abaya area development program has contributed for the reduction of cattle disease\" said the young veterinary specialist. ",
                "url": "http://mrs.worldvision.org/mgen/imageSize.ms?args=\"psi:/185551/185551_20130809_102040_OCP.jpg\",640,480&jp=1",
                "lastModifiedDate": "2023-01-13T07:04:10",
                "mediaDate": "2013-08-09T10:20:40"
            },
            {
                "contentTypeCode": "OCP",
                "format": "thumb",
                "subtypeCode": "ST549",
                "subtypeDescription": "Livelihood",
                "captionForSupporter": "The newly constructed cattle crash by world vision Ethiopia Abaya area development program has contributed for the reduction of cattle disease\" said the young veterinary specialist. ",
                "url": "http://mrs.worldvision.org/mgen/imageSize.ms?args=\"psi:/185551/185551_20130809_102040_OCP_thumb.jpg\",150,112&jp=1",
                "lastModifiedDate": "2023-01-13T07:04:10",
                "mediaDate": "2013-08-09T10:20:40"
            },
            {
                "contentTypeCode": "OCP",
                "format": "original",
                "subtypeCode": "ST549",
                "subtypeDescription": "Livelihood",
                "captionForSupporter": "The newly constructed cattle crash by world vision Ethiopia Abaya area development program has contributed for the reduction of cattle disease\" said the young veterinary specialist. ",
                "url": "http://mrs.worldvision.org/mgen/psi:/185551/185551_20130809_102040_OCP.jpg",
                "lastModifiedDate": "2023-01-13T07:04:10",
                "mediaDate": "2013-08-09T10:20:40"
            },
            {
                "contentTypeCode": "OCP",
                "format": "web",
                "subtypeCode": "ST549",
                "subtypeDescription": "Livelihood",
                "captionForSupporter": "Mr. Edema Dekemo a farmer in Abaya area has said that the introduction of improved corn seed variety by world vision Ethiopia has increased maize crop production and productivity. ",
                "url": "http://mrs.worldvision.org/mgen/imageSize.ms?args=\"psi:/185551/185551_20130809_102016_OCP.jpg\",640,480&jp=1",
                "lastModifiedDate": "2023-01-13T07:04:10",
                "mediaDate": "2013-08-09T10:20:16"
            },
            {
                "contentTypeCode": "OCP",
                "format": "thumb",
                "subtypeCode": "ST549",
                "subtypeDescription": "Livelihood",
                "captionForSupporter": "Mr. Edema Dekemo a farmer in Abaya area has said that the introduction of improved corn seed variety by world vision Ethiopia has increased maize crop production and productivity. ",
                "url": "http://mrs.worldvision.org/mgen/imageSize.ms?args=\"psi:/185551/185551_20130809_102016_OCP_thumb.jpg\",150,112&jp=1",
                "lastModifiedDate": "2023-01-13T07:04:10",
                "mediaDate": "2013-08-09T10:20:16"
            },
            {
                "contentTypeCode": "OCP",
                "format": "original",
                "subtypeCode": "ST549",
                "subtypeDescription": "Livelihood",
                "captionForSupporter": "Mr. Edema Dekemo a farmer in Abaya area has said that the introduction of improved corn seed variety by world vision Ethiopia has increased maize crop production and productivity. ",
                "url": "http://mrs.worldvision.org/mgen/psi:/185551/185551_20130809_102016_OCP.jpg",
                "lastModifiedDate": "2023-01-13T07:04:10",
                "mediaDate": "2013-08-09T10:20:16"
            },
            {
                "contentTypeCode": "OCP",
                "format": "web",
                "subtypeCode": "ST549",
                "subtypeDescription": "Livelihood",
                "captionForSupporter": "Following the training on pottery production offered by world vision Ethiopia Abaya area development program, we are able to construct different pottery products and sell to local community. The training has helped to increase our income.",
                "url": "http://mrs.worldvision.org/mgen/imageSize.ms?args=\"psi:/185551/185551_20120425_172848_OCP.jpg\",640,480&jp=1",
                "lastModifiedDate": "2023-01-13T07:04:10",
                "mediaDate": "2012-04-25T17:28:48"
            },
            {
                "contentTypeCode": "OCP",
                "format": "thumb",
                "subtypeCode": "ST549",
                "subtypeDescription": "Livelihood",
                "captionForSupporter": "Following the training on pottery production offered by world vision Ethiopia Abaya area development program, we are able to construct different pottery products and sell to local community. The training has helped to increase our income.",
                "url": "http://mrs.worldvision.org/mgen/imageSize.ms?args=\"psi:/185551/185551_20120425_172848_OCP_thumb.jpg\",150,112&jp=1",
                "lastModifiedDate": "2023-01-13T07:04:10",
                "mediaDate": "2012-04-25T17:28:48"
            },
            {
                "contentTypeCode": "OCP",
                "format": "original",
                "subtypeCode": "ST549",
                "subtypeDescription": "Livelihood",
                "captionForSupporter": "Following the training on pottery production offered by world vision Ethiopia Abaya area development program, we are able to construct different pottery products and sell to local community. The training has helped to increase our income.",
                "url": "http://mrs.worldvision.org/mgen/psi:/185551/185551_20120425_172848_OCP.jpg",
                "lastModifiedDate": "2023-01-13T07:04:10",
                "mediaDate": "2012-04-25T17:28:48"
            },
            {
                "contentTypeCode": "OCP",
                "format": "original",
                "subtypeCode": "ST555",
                "subtypeDescription": "Water",
                "captionForSupporter": "One of the woman who is fetching the water said \"We were used to travel long distance to access water. But now due to the construction of shallow well by World Vision we are able to access clean water in the nearby area\" ",
                "url": "https://d3cfrqjucqh0ip.cloudfront.net/project/images/185551_20140628_094219_OCP.JPG",
                "lastModifiedDate": "2023-01-13T07:04:10",
                "mediaDate": "2014-06-28T09:42:19"
            },
            {
                "contentTypeCode": "OCP",
                "format": "web",
                "subtypeCode": "ST555",
                "subtypeDescription": "Water",
                "captionForSupporter": "One of the woman who is fetching the water said \"We were used to travel long distance to access water. But now due to the construction of shallow well by World Vision we are able to access clean water in the nearby area\" ",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20140628_094219_OCP.JPG",
                "lastModifiedDate": "2023-01-13T07:04:10",
                "mediaDate": "2014-06-28T09:42:19"
            },
            {
                "contentTypeCode": "OCP",
                "format": "thumb",
                "subtypeCode": "ST555",
                "subtypeDescription": "Water",
                "captionForSupporter": "One of the woman who is fetching the water said \"We were used to travel long distance to access water. But now due to the construction of shallow well by World Vision we are able to access clean water in the nearby area\" ",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20140628_094219_OCP_thumb.jpg",
                "lastModifiedDate": "2023-01-13T07:04:10",
                "mediaDate": "2014-06-28T09:42:19"
            },
            {
                "contentTypeCode": "YIV",
                "format": "vthumb",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": "Take a look at everyday life in your sponsored child's community to see where they live, what brings them joy, and the challenges that your donations are helping to overcome.",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20130129_141507_YIV_vThumb.png",
                "lastModifiedDate": "2014-11-13T18:49:33",
                "mediaDate": "2013-01-29T14:15:07"
            },
            {
                "contentTypeCode": "YIV",
                "format": "ipad",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": "Take a look at everyday life in your sponsored child's community to see where they live, what brings them joy, and the challenges that your donations are helping to overcome.",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/video/185551_20130129_141507_YIV_iPad.mp4",
                "lastModifiedDate": "2014-11-13T18:49:33",
                "mediaDate": "2013-01-29T14:15:07"
            },
            {
                "contentTypeCode": "YIV",
                "format": "mob",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": "Take a look at everyday life in your sponsored child's community to see where they live, what brings them joy, and the challenges that your donations are helping to overcome.",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/video/185551_20130129_141507_YIV_Mob.mp4",
                "lastModifiedDate": "2014-11-13T18:49:33",
                "mediaDate": "2013-01-29T14:15:07"
            },
            {
                "contentTypeCode": "YIV",
                "format": "web",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": "Take a look at everyday life in your sponsored child's community to see where they live, what brings them joy, and the challenges that your donations are helping to overcome.",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/video/185551_20130129_141507_YIV_Web.mp4",
                "lastModifiedDate": "2014-11-13T18:49:33",
                "mediaDate": "2013-01-29T14:15:07"
            },
            {
                "contentTypeCode": "YUP",
                "format": "original",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": "\"I have got this experience sharing from world vision through farmer irrigation user group in my kebele.\"said Asirat,  40, one of the model farmer  \"After the World Vision provided us this opportunity I totally neglected the local seed since I observed a big difference between them. ",
                "url": "https://d3cfrqjucqh0ip.cloudfront.net/project/images/185551_20150814_161655_YUP.JPG",
                "lastModifiedDate": "2015-09-11T00:05:57",
                "mediaDate": "2015-08-14T16:16:55"
            },
            {
                "contentTypeCode": "YUP",
                "format": "web",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": "\"I have got this experience sharing from world vision through farmer irrigation user group in my kebele.\"said Asirat,  40, one of the model farmer  \"After the World Vision provided us this opportunity I totally neglected the local seed since I observed a big difference between them. ",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20150814_161655_YUP.JPG",
                "lastModifiedDate": "2015-09-11T00:05:57",
                "mediaDate": "2015-08-14T16:16:55"
            },
            {
                "contentTypeCode": "YUP",
                "format": "thumb",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": "\"I have got this experience sharing from world vision through farmer irrigation user group in my kebele.\"said Asirat,  40, one of the model farmer  \"After the World Vision provided us this opportunity I totally neglected the local seed since I observed a big difference between them. ",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20150814_161655_YUP_thumb.jpg",
                "lastModifiedDate": "2015-09-11T00:05:57",
                "mediaDate": "2015-08-14T16:16:55"
            },
            {
                "contentTypeCode": "YUP",
                "format": "original",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": "\"Our district has no sufficient budget to protect the degraded land .We have a golden opportunity from World Vision.\" Said Bekele Ota, 30, the district natural resource management unit expert \"With the support of the world vision in farmer managed natural resource program soil and water is conserved",
                "url": "https://d3cfrqjucqh0ip.cloudfront.net/project/images/185551_20150814_035642_YUP.JPG",
                "lastModifiedDate": "2015-09-11T00:05:57",
                "mediaDate": "2015-08-14T03:56:42"
            },
            {
                "contentTypeCode": "YUP",
                "format": "web",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": "\"Our district has no sufficient budget to protect the degraded land .We have a golden opportunity from World Vision.\" Said Bekele Ota, 30, the district natural resource management unit expert \"With the support of the world vision in farmer managed natural resource program soil and water is conserved",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20150814_035642_YUP.JPG",
                "lastModifiedDate": "2015-09-11T00:05:57",
                "mediaDate": "2015-08-14T03:56:42"
            },
            {
                "contentTypeCode": "YUP",
                "format": "thumb",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": "\"Our district has no sufficient budget to protect the degraded land .We have a golden opportunity from World Vision.\" Said Bekele Ota, 30, the district natural resource management unit expert \"With the support of the world vision in farmer managed natural resource program soil and water is conserved",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20150814_035642_YUP_thumb.jpg",
                "lastModifiedDate": "2015-09-11T00:05:57",
                "mediaDate": "2015-08-14T03:56:42"
            },
            {
                "contentTypeCode": "YUP",
                "format": "original",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": "\"After school we have got an opportunity to practice in the reading camp with the help of volunteer’s. We really improve our reading skill and study habit. Thanks to World Vision the camp has been furnished with different reading book and tools.\" Said by konjit, age 10.",
                "url": "https://d3cfrqjucqh0ip.cloudfront.net/project/images/185551_20150814_035634_YUP.JPG",
                "lastModifiedDate": "2015-09-11T00:13:55",
                "mediaDate": "2015-08-14T03:56:34"
            },
            {
                "contentTypeCode": "YUP",
                "format": "web",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": "\"After school we have got an opportunity to practice in the reading camp with the help of volunteer’s. We really improve our reading skill and study habit. Thanks to World Vision the camp has been furnished with different reading book and tools.\" Said by konjit, age 10.",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20150814_035634_YUP.JPG",
                "lastModifiedDate": "2015-09-11T00:13:55",
                "mediaDate": "2015-08-14T03:56:34"
            },
            {
                "contentTypeCode": "YUP",
                "format": "thumb",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": "\"After school we have got an opportunity to practice in the reading camp with the help of volunteer’s. We really improve our reading skill and study habit. Thanks to World Vision the camp has been furnished with different reading book and tools.\" Said by konjit, age 10.",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20150814_035634_YUP_thumb.jpg",
                "lastModifiedDate": "2015-09-11T00:13:55",
                "mediaDate": "2015-08-14T03:56:34"
            },
            {
                "contentTypeCode": "YUP",
                "format": "original",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": "\"Before we started ODF (open defecation free) program with world vision our community was not given attention about appropriate defecation. ’said Gutema 31 old representing his community .He continues saying \"Thanks to world vision today the community aware & leads to assure the sanitation process.\"",
                "url": "https://d3cfrqjucqh0ip.cloudfront.net/project/images/185551_20150814_035608_YUP.JPG",
                "lastModifiedDate": "2015-09-11T00:13:55",
                "mediaDate": "2015-08-14T03:56:08"
            },
            {
                "contentTypeCode": "YUP",
                "format": "web",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": "\"Before we started ODF (open defecation free) program with world vision our community was not given attention about appropriate defecation. ’said Gutema 31 old representing his community .He continues saying \"Thanks to world vision today the community aware & leads to assure the sanitation process.\"",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20150814_035608_YUP.JPG",
                "lastModifiedDate": "2015-09-11T00:13:55",
                "mediaDate": "2015-08-14T03:56:08"
            },
            {
                "contentTypeCode": "YUP",
                "format": "thumb",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": "\"Before we started ODF (open defecation free) program with world vision our community was not given attention about appropriate defecation. ’said Gutema 31 old representing his community .He continues saying \"Thanks to world vision today the community aware & leads to assure the sanitation process.\"",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20150814_035608_YUP_thumb.jpg",
                "lastModifiedDate": "2015-09-11T00:13:55",
                "mediaDate": "2015-08-14T03:56:08"
            },
            {
                "contentTypeCode": "YUP",
                "format": "original",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": "\"Our district has no sufficient budget to protect the degraded land .We have a golden opportunity from World Vision.\" Said Bekele Ota, 30, the district natural resource management unit expert \"With the support of the world vision in farmer managed natural resource program soil and water is conserved",
                "url": "https://d3cfrqjucqh0ip.cloudfront.net/project/images/185551_20150814_035548_YUP.JPG",
                "lastModifiedDate": "2015-09-11T00:13:55",
                "mediaDate": "2015-08-14T03:55:48"
            },
            {
                "contentTypeCode": "YUP",
                "format": "web",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": "\"Our district has no sufficient budget to protect the degraded land .We have a golden opportunity from World Vision.\" Said Bekele Ota, 30, the district natural resource management unit expert \"With the support of the world vision in farmer managed natural resource program soil and water is conserved",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20150814_035548_YUP.JPG",
                "lastModifiedDate": "2015-09-11T00:13:55",
                "mediaDate": "2015-08-14T03:55:48"
            },
            {
                "contentTypeCode": "YUP",
                "format": "thumb",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": "\"Our district has no sufficient budget to protect the degraded land .We have a golden opportunity from World Vision.\" Said Bekele Ota, 30, the district natural resource management unit expert \"With the support of the world vision in farmer managed natural resource program soil and water is conserved",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20150814_035548_YUP_thumb.jpg",
                "lastModifiedDate": "2015-09-11T00:13:55",
                "mediaDate": "2015-08-14T03:55:48"
            },
            {
                "contentTypeCode": "YUP",
                "format": "original",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": "\"We have got this pure water in our village which is constructed by world vision .As the result, we are protected from different types of water born disease. Thanks to world vision, today we are free from this entire problem and started to attend school appropriately.\" Said by Ayayntu ,age 19.",
                "url": "https://d3cfrqjucqh0ip.cloudfront.net/project/images/185551_20150814_035534_YUP.JPG",
                "lastModifiedDate": "2015-09-11T00:13:55",
                "mediaDate": "2015-08-14T03:55:34"
            },
            {
                "contentTypeCode": "YUP",
                "format": "web",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": "\"We have got this pure water in our village which is constructed by world vision .As the result, we are protected from different types of water born disease. Thanks to world vision, today we are free from this entire problem and started to attend school appropriately.\" Said by Ayayntu ,age 19.",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20150814_035534_YUP.JPG",
                "lastModifiedDate": "2015-09-11T00:13:55",
                "mediaDate": "2015-08-14T03:55:34"
            },
            {
                "contentTypeCode": "YUP",
                "format": "thumb",
                "subtypeCode": "",
                "subtypeDescription": "",
                "captionForSupporter": "\"We have got this pure water in our village which is constructed by world vision .As the result, we are protected from different types of water born disease. Thanks to world vision, today we are free from this entire problem and started to attend school appropriately.\" Said by Ayayntu ,age 19.",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20150814_035534_YUP_thumb.jpg",
                "lastModifiedDate": "2015-09-11T00:13:55",
                "mediaDate": "2015-08-14T03:55:34"
            },
            {
                "contentTypeCode": "YUP",
                "format": "original",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "\"Reading camp established through community participation is improving our reading performance which also resulted in decrement of school absenteeism.\" Mimi ,10 years old.",
                "url": "https://d3cfrqjucqh0ip.cloudfront.net/project/images/185551_20190211_233645_YUP.JPG",
                "lastModifiedDate": "2019-06-24T07:58:17",
                "mediaDate": "2019-02-11T23:36:45"
            },
            {
                "contentTypeCode": "YUP",
                "format": "web",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "\"Reading camp established through community participation is improving our reading performance which also resulted in decrement of school absenteeism.\" Mimi ,10 years old.",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20190211_233645_YUP.JPG",
                "lastModifiedDate": "2019-06-24T07:58:17",
                "mediaDate": "2019-02-11T23:36:45"
            },
            {
                "contentTypeCode": "YUP",
                "format": "thumb",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "\"Reading camp established through community participation is improving our reading performance which also resulted in decrement of school absenteeism.\" Mimi ,10 years old.",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20190211_233645_YUP_thumb.jpg",
                "lastModifiedDate": "2019-06-24T07:58:17",
                "mediaDate": "2019-02-11T23:36:45"
            },
            {
                "contentTypeCode": "YUP",
                "format": "original",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "\"Community mobilization and sensitization are done together for a few selected representatives members of the neighbour villages about open defecation free that the knowledge is replicated to those villages and so that the villages become clean and free from open defecation .\" Mingistu, admistrative",
                "url": "https://d3cfrqjucqh0ip.cloudfront.net/project/images/185551_20190211_233643_YUP.JPG",
                "lastModifiedDate": "2019-06-24T07:58:17",
                "mediaDate": "2019-02-11T23:36:43"
            },
            {
                "contentTypeCode": "YUP",
                "format": "web",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "\"Community mobilization and sensitization are done together for a few selected representatives members of the neighbour villages about open defecation free that the knowledge is replicated to those villages and so that the villages become clean and free from open defecation .\" Mingistu, admistrative",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20190211_233643_YUP.JPG",
                "lastModifiedDate": "2019-06-24T07:58:17",
                "mediaDate": "2019-02-11T23:36:43"
            },
            {
                "contentTypeCode": "YUP",
                "format": "thumb",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "\"Community mobilization and sensitization are done together for a few selected representatives members of the neighbour villages about open defecation free that the knowledge is replicated to those villages and so that the villages become clean and free from open defecation .\" Mingistu, admistrative",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20190211_233643_YUP_thumb.jpg",
                "lastModifiedDate": "2019-06-24T07:58:17",
                "mediaDate": "2019-02-11T23:36:43"
            },
            {
                "contentTypeCode": "YUP",
                "format": "original",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "\"We have got different types of teaching aid materials after our teachers’ trained Early Child Development (ECD) training via WV. Now, we have enabled to learn more of practical things which highly improve our skills of creativity. ‘’ Hana ,11 years old .",
                "url": "https://d3cfrqjucqh0ip.cloudfront.net/project/images/185551_20190211_233639_YUP.JPG",
                "lastModifiedDate": "2019-06-24T07:58:17",
                "mediaDate": "2019-02-11T23:36:39"
            },
            {
                "contentTypeCode": "YUP",
                "format": "web",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "\"We have got different types of teaching aid materials after our teachers’ trained Early Child Development (ECD) training via WV. Now, we have enabled to learn more of practical things which highly improve our skills of creativity. ‘’ Hana ,11 years old .",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20190211_233639_YUP.JPG",
                "lastModifiedDate": "2019-06-24T07:58:17",
                "mediaDate": "2019-02-11T23:36:39"
            },
            {
                "contentTypeCode": "YUP",
                "format": "thumb",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "\"We have got different types of teaching aid materials after our teachers’ trained Early Child Development (ECD) training via WV. Now, we have enabled to learn more of practical things which highly improve our skills of creativity. ‘’ Hana ,11 years old .",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20190211_233639_YUP_thumb.jpg",
                "lastModifiedDate": "2019-06-24T07:58:17",
                "mediaDate": "2019-02-11T23:36:39"
            },
            {
                "contentTypeCode": "YUP",
                "format": "original",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "‘’In our community one of the major achievement is working on galley shaping activities to protect erosion and recover degraded land .This activity enhanced the farmers to use the land in effective way and increased their production .’’ Gurmessa , 45 farmer in Semero village.",
                "url": "https://d3cfrqjucqh0ip.cloudfront.net/project/images/185551_20190211_233635_YUP.JPG",
                "lastModifiedDate": "2019-06-24T07:58:17",
                "mediaDate": "2019-02-11T23:36:35"
            },
            {
                "contentTypeCode": "YUP",
                "format": "web",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "‘’In our community one of the major achievement is working on galley shaping activities to protect erosion and recover degraded land .This activity enhanced the farmers to use the land in effective way and increased their production .’’ Gurmessa , 45 farmer in Semero village.",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20190211_233635_YUP.JPG",
                "lastModifiedDate": "2019-06-24T07:58:17",
                "mediaDate": "2019-02-11T23:36:35"
            },
            {
                "contentTypeCode": "YUP",
                "format": "thumb",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "‘’In our community one of the major achievement is working on galley shaping activities to protect erosion and recover degraded land .This activity enhanced the farmers to use the land in effective way and increased their production .’’ Gurmessa , 45 farmer in Semero village.",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20190211_233635_YUP_thumb.jpg",
                "lastModifiedDate": "2019-06-24T07:58:17",
                "mediaDate": "2019-02-11T23:36:35"
            },
            {
                "contentTypeCode": "YUP",
                "format": "original",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "\"World Vision has provided me training on production and management of vegetables, how to use irrigation, supported me with provision of initial seed of cabbage and arranged an opportunity to share experience from better area in the subject matter. \" Says ,Alemayehu a father of 5 ",
                "url": "https://d3cfrqjucqh0ip.cloudfront.net/project/images/185551_20190211_233629_YUP.JPG",
                "lastModifiedDate": "2019-06-24T07:58:17",
                "mediaDate": "2019-02-11T23:36:29"
            },
            {
                "contentTypeCode": "YUP",
                "format": "web",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "\"World Vision has provided me training on production and management of vegetables, how to use irrigation, supported me with provision of initial seed of cabbage and arranged an opportunity to share experience from better area in the subject matter. \" Says ,Alemayehu a father of 5 ",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20190211_233629_YUP.JPG",
                "lastModifiedDate": "2019-06-24T07:58:17",
                "mediaDate": "2019-02-11T23:36:29"
            },
            {
                "contentTypeCode": "YUP",
                "format": "thumb",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "\"World Vision has provided me training on production and management of vegetables, how to use irrigation, supported me with provision of initial seed of cabbage and arranged an opportunity to share experience from better area in the subject matter. \" Says ,Alemayehu a father of 5 ",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20190211_233629_YUP_thumb.jpg",
                "lastModifiedDate": "2019-06-24T07:58:17",
                "mediaDate": "2019-02-11T23:36:29"
            },
            {
                "contentTypeCode": "YUP",
                "format": "original",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "Derartu of 13, a 6th grader says, \"Formerly we used to fetch water from long distances which consume our time and energy. Thanks to World Vision, we now have accessed clean water in front of our homes and have ample time to study, play and support with other domestic chores. \" ",
                "url": "https://d3cfrqjucqh0ip.cloudfront.net/project/images/185551_20180619_210419_YUP.JPG",
                "lastModifiedDate": "2018-06-26T20:43:14",
                "mediaDate": "2018-06-19T21:04:19"
            },
            {
                "contentTypeCode": "YUP",
                "format": "web",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "Derartu of 13, a 6th grader says, \"Formerly we used to fetch water from long distances which consume our time and energy. Thanks to World Vision, we now have accessed clean water in front of our homes and have ample time to study, play and support with other domestic chores. \" ",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20180619_210419_YUP.JPG",
                "lastModifiedDate": "2018-06-26T20:43:14",
                "mediaDate": "2018-06-19T21:04:19"
            },
            {
                "contentTypeCode": "YUP",
                "format": "thumb",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "Derartu of 13, a 6th grader says, \"Formerly we used to fetch water from long distances which consume our time and energy. Thanks to World Vision, we now have accessed clean water in front of our homes and have ample time to study, play and support with other domestic chores. \" ",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20180619_210419_YUP_thumb.jpg",
                "lastModifiedDate": "2018-06-26T20:43:14",
                "mediaDate": "2018-06-19T21:04:19"
            },
            {
                "contentTypeCode": "YUP",
                "format": "original",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "\"After conducting capacity building training for parents on antenatal & postnatal care, skilled delivery has increased and home delivery is significantly decreased. Due to this, the risks and complications mother face during delivery has reduced significantly, \"says Tsega of 35, mid wife.",
                "url": "https://d3cfrqjucqh0ip.cloudfront.net/project/images/185551_20180619_210413_YUP.JPG",
                "lastModifiedDate": "2018-06-26T20:56:13",
                "mediaDate": "2018-06-19T21:04:13"
            },
            {
                "contentTypeCode": "YUP",
                "format": "web",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "\"After conducting capacity building training for parents on antenatal & postnatal care, skilled delivery has increased and home delivery is significantly decreased. Due to this, the risks and complications mother face during delivery has reduced significantly, \"says Tsega of 35, mid wife.",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20180619_210413_YUP.JPG",
                "lastModifiedDate": "2018-06-26T20:56:13",
                "mediaDate": "2018-06-19T21:04:13"
            },
            {
                "contentTypeCode": "YUP",
                "format": "thumb",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "\"After conducting capacity building training for parents on antenatal & postnatal care, skilled delivery has increased and home delivery is significantly decreased. Due to this, the risks and complications mother face during delivery has reduced significantly, \"says Tsega of 35, mid wife.",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20180619_210413_YUP_thumb.jpg",
                "lastModifiedDate": "2018-06-26T20:56:13",
                "mediaDate": "2018-06-19T21:04:13"
            },
            {
                "contentTypeCode": "YUP",
                "format": "original",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "Milkias of 14, a 7th grader says,  \"Awareness creation training on child right by world vision  in the form of group discussion  helped us to develop a good understanding about child right .Now my friends and me know how to exercise our rights as well as protect others from any kinds of child abuse.",
                "url": "https://d3cfrqjucqh0ip.cloudfront.net/project/images/185551_20180619_210411_YUP.JPG",
                "lastModifiedDate": "2018-06-26T20:56:13",
                "mediaDate": "2018-06-19T21:04:11"
            },
            {
                "contentTypeCode": "YUP",
                "format": "web",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "Milkias of 14, a 7th grader says,  \"Awareness creation training on child right by world vision  in the form of group discussion  helped us to develop a good understanding about child right .Now my friends and me know how to exercise our rights as well as protect others from any kinds of child abuse.",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20180619_210411_YUP.JPG",
                "lastModifiedDate": "2018-06-26T20:56:13",
                "mediaDate": "2018-06-19T21:04:11"
            },
            {
                "contentTypeCode": "YUP",
                "format": "thumb",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "Milkias of 14, a 7th grader says,  \"Awareness creation training on child right by world vision  in the form of group discussion  helped us to develop a good understanding about child right .Now my friends and me know how to exercise our rights as well as protect others from any kinds of child abuse.",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20180619_210411_YUP_thumb.jpg",
                "lastModifiedDate": "2018-06-26T20:56:13",
                "mediaDate": "2018-06-19T21:04:11"
            },
            {
                "contentTypeCode": "YUP",
                "format": "original",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "\"We all were jobless before. After world vision supported us with different trainings and inputs, now we are improving with the business so much. As we are creating access to sanitary facilities, we are also creating job opportunities for ourselves and even for others\", says Birtukan of 18.",
                "url": "https://d3cfrqjucqh0ip.cloudfront.net/project/images/185551_20180619_210351_YUP.JPG",
                "lastModifiedDate": "2018-06-26T20:56:13",
                "mediaDate": "2018-06-19T21:03:51"
            },
            {
                "contentTypeCode": "YUP",
                "format": "web",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "\"We all were jobless before. After world vision supported us with different trainings and inputs, now we are improving with the business so much. As we are creating access to sanitary facilities, we are also creating job opportunities for ourselves and even for others\", says Birtukan of 18.",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20180619_210351_YUP.JPG",
                "lastModifiedDate": "2018-06-26T20:56:13",
                "mediaDate": "2018-06-19T21:03:51"
            },
            {
                "contentTypeCode": "YUP",
                "format": "thumb",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "\"We all were jobless before. After world vision supported us with different trainings and inputs, now we are improving with the business so much. As we are creating access to sanitary facilities, we are also creating job opportunities for ourselves and even for others\", says Birtukan of 18.",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20180619_210351_YUP_thumb.jpg",
                "lastModifiedDate": "2018-06-26T20:56:13",
                "mediaDate": "2018-06-19T21:03:51"
            },
            {
                "contentTypeCode": "YUP",
                "format": "original",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "\"We are preparing different types of teaching aid materials after we have got ECD training from WV. Now, we are able to teach more of practical things which highly improve our skills of creativity. Besides, it changed the methodology & understanding of teachers in the teaching process,\" Birtukan 35.",
                "url": "https://d3cfrqjucqh0ip.cloudfront.net/project/images/185551_20180619_210249_YUP.JPG",
                "lastModifiedDate": "2018-06-22T17:19:46",
                "mediaDate": "2018-06-19T21:02:49"
            },
            {
                "contentTypeCode": "YUP",
                "format": "web",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "\"We are preparing different types of teaching aid materials after we have got ECD training from WV. Now, we are able to teach more of practical things which highly improve our skills of creativity. Besides, it changed the methodology & understanding of teachers in the teaching process,\" Birtukan 35.",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20180619_210249_YUP.JPG",
                "lastModifiedDate": "2018-06-22T17:19:46",
                "mediaDate": "2018-06-19T21:02:49"
            },
            {
                "contentTypeCode": "YUP",
                "format": "thumb",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "\"We are preparing different types of teaching aid materials after we have got ECD training from WV. Now, we are able to teach more of practical things which highly improve our skills of creativity. Besides, it changed the methodology & understanding of teachers in the teaching process,\" Birtukan 35.",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20180619_210249_YUP_thumb.jpg",
                "lastModifiedDate": "2018-06-22T17:19:46",
                "mediaDate": "2018-06-19T21:02:49"
            },
            {
                "contentTypeCode": "YUP",
                "format": "original",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "\"The dialogue which is conducted by world vision about role and responsibility of children is enabling to know our position in society. Now, we understand that each of us has a multiple roles & responsibility in our life; in different contexts or with different people .\"says ,Durassa ,13.",
                "url": "https://d3cfrqjucqh0ip.cloudfront.net/project/images/185551_20170608_201535_YUP.JPG",
                "lastModifiedDate": "2017-07-30T05:49:09",
                "mediaDate": "2017-06-08T20:15:35"
            },
            {
                "contentTypeCode": "YUP",
                "format": "web",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "\"The dialogue which is conducted by world vision about role and responsibility of children is enabling to know our position in society. Now, we understand that each of us has a multiple roles & responsibility in our life; in different contexts or with different people .\"says ,Durassa ,13.",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20170608_201535_YUP.JPG",
                "lastModifiedDate": "2017-07-30T05:49:09",
                "mediaDate": "2017-06-08T20:15:35"
            },
            {
                "contentTypeCode": "YUP",
                "format": "thumb",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "\"The dialogue which is conducted by world vision about role and responsibility of children is enabling to know our position in society. Now, we understand that each of us has a multiple roles & responsibility in our life; in different contexts or with different people .\"says ,Durassa ,13.",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20170608_201535_YUP_thumb.jpg",
                "lastModifiedDate": "2017-07-30T05:49:09",
                "mediaDate": "2017-06-08T20:15:35"
            },
            {
                "contentTypeCode": "YUP",
                "format": "original",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "‘’Thanks to world vision, all intervention area of 21 village of the house hold have private latrine & at least two communal latrines in each village. Children are most vulnerable part of the community due to diseases that are related to poor sanitation & hygiene.\" Says Ato Eluf",
                "url": "https://d3cfrqjucqh0ip.cloudfront.net/project/images/185551_20170608_201527_YUP.JPG",
                "lastModifiedDate": "2017-07-21T21:57:05",
                "mediaDate": "2017-06-08T20:15:27"
            },
            {
                "contentTypeCode": "YUP",
                "format": "web",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "‘’Thanks to world vision, all intervention area of 21 village of the house hold have private latrine & at least two communal latrines in each village. Children are most vulnerable part of the community due to diseases that are related to poor sanitation & hygiene.\" Says Ato Eluf",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20170608_201527_YUP.JPG",
                "lastModifiedDate": "2017-07-21T21:57:05",
                "mediaDate": "2017-06-08T20:15:27"
            },
            {
                "contentTypeCode": "YUP",
                "format": "thumb",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "‘’Thanks to world vision, all intervention area of 21 village of the house hold have private latrine & at least two communal latrines in each village. Children are most vulnerable part of the community due to diseases that are related to poor sanitation & hygiene.\" Says Ato Eluf",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20170608_201527_YUP_thumb.jpg",
                "lastModifiedDate": "2017-07-21T21:57:05",
                "mediaDate": "2017-06-08T20:15:27"
            },
            {
                "contentTypeCode": "YUP",
                "format": "original",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "\"Thanks to world vision the purchased of different livestock drugs and undertaking treatment for livestock able to prevent different livestock disease such as : Treps (Gendi), Fasiolia, and different Bacteria.\" ,Tadele 34 , one the community representative.",
                "url": "https://d3cfrqjucqh0ip.cloudfront.net/project/images/185551_20170608_201517_YUP.JPG",
                "lastModifiedDate": "2017-07-21T21:57:05",
                "mediaDate": "2017-06-08T20:15:17"
            },
            {
                "contentTypeCode": "YUP",
                "format": "web",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "\"Thanks to world vision the purchased of different livestock drugs and undertaking treatment for livestock able to prevent different livestock disease such as : Treps (Gendi), Fasiolia, and different Bacteria.\" ,Tadele 34 , one the community representative.",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20170608_201517_YUP.JPG",
                "lastModifiedDate": "2017-07-21T21:57:05",
                "mediaDate": "2017-06-08T20:15:17"
            },
            {
                "contentTypeCode": "YUP",
                "format": "thumb",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "\"Thanks to world vision the purchased of different livestock drugs and undertaking treatment for livestock able to prevent different livestock disease such as : Treps (Gendi), Fasiolia, and different Bacteria.\" ,Tadele 34 , one the community representative.",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20170608_201517_YUP_thumb.jpg",
                "lastModifiedDate": "2017-07-21T21:57:05",
                "mediaDate": "2017-06-08T20:15:17"
            },
            {
                "contentTypeCode": "YUP",
                "format": "original",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "\"Children in Abaya district are enjoying reading books everywhere because world vision understand that reading is one of the basic building blocks for children’s lifelong learning, success in school and sustainable development and supply them with various reading materials.\"  Haimanot 31",
                "url": "https://d3cfrqjucqh0ip.cloudfront.net/project/images/185551_20170608_201457_YUP.JPG",
                "lastModifiedDate": "2017-07-21T21:57:05",
                "mediaDate": "2017-06-08T20:14:57"
            },
            {
                "contentTypeCode": "YUP",
                "format": "web",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "\"Children in Abaya district are enjoying reading books everywhere because world vision understand that reading is one of the basic building blocks for children’s lifelong learning, success in school and sustainable development and supply them with various reading materials.\"  Haimanot 31",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20170608_201457_YUP.JPG",
                "lastModifiedDate": "2017-07-21T21:57:05",
                "mediaDate": "2017-06-08T20:14:57"
            },
            {
                "contentTypeCode": "YUP",
                "format": "thumb",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "\"Children in Abaya district are enjoying reading books everywhere because world vision understand that reading is one of the basic building blocks for children’s lifelong learning, success in school and sustainable development and supply them with various reading materials.\"  Haimanot 31",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20170608_201457_YUP_thumb.jpg",
                "lastModifiedDate": "2017-07-21T21:57:05",
                "mediaDate": "2017-06-08T20:14:57"
            },
            {
                "contentTypeCode": "YUP",
                "format": "original",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "\"Mosquito is the main disease in our community sometimes children are dropped from school. Awareness creation training & the distribution of mosquito net by world vision dramatically decreased & prevent the community from the disease, especially mothers & baby.\" Deratu, 25",
                "url": "https://d3cfrqjucqh0ip.cloudfront.net/project/images/185551_20170608_201447_YUP.JPG",
                "lastModifiedDate": "2017-07-21T21:57:05",
                "mediaDate": "2017-06-08T20:14:47"
            },
            {
                "contentTypeCode": "YUP",
                "format": "web",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "\"Mosquito is the main disease in our community sometimes children are dropped from school. Awareness creation training & the distribution of mosquito net by world vision dramatically decreased & prevent the community from the disease, especially mothers & baby.\" Deratu, 25",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20170608_201447_YUP.JPG",
                "lastModifiedDate": "2017-07-21T21:57:05",
                "mediaDate": "2017-06-08T20:14:47"
            },
            {
                "contentTypeCode": "YUP",
                "format": "thumb",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "\"Mosquito is the main disease in our community sometimes children are dropped from school. Awareness creation training & the distribution of mosquito net by world vision dramatically decreased & prevent the community from the disease, especially mothers & baby.\" Deratu, 25",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20170608_201447_YUP_thumb.jpg",
                "lastModifiedDate": "2017-07-21T21:57:05",
                "mediaDate": "2017-06-08T20:14:47"
            },
            {
                "contentTypeCode": "YUP",
                "format": "original",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "\"Thanks to world vision due to the establishment of child center in our village, me and my friends recreate in the center. Now, children don’t waste their free time inappropriate place.  \"says , Konjit ,11.",
                "url": "https://d3cfrqjucqh0ip.cloudfront.net/project/images/185551_20160908_161733_YUP.JPG",
                "lastModifiedDate": "2017-01-06T19:55:09",
                "mediaDate": "2016-09-08T16:17:33"
            },
            {
                "contentTypeCode": "YUP",
                "format": "web",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "\"Thanks to world vision due to the establishment of child center in our village, me and my friends recreate in the center. Now, children don’t waste their free time inappropriate place.  \"says , Konjit ,11.",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20160908_161733_YUP.JPG",
                "lastModifiedDate": "2017-01-06T19:55:09",
                "mediaDate": "2016-09-08T16:17:33"
            },
            {
                "contentTypeCode": "YUP",
                "format": "thumb",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "\"Thanks to world vision due to the establishment of child center in our village, me and my friends recreate in the center. Now, children don’t waste their free time inappropriate place.  \"says , Konjit ,11.",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20160908_161733_YUP_thumb.jpg",
                "lastModifiedDate": "2017-01-06T19:55:09",
                "mediaDate": "2016-09-08T16:17:33"
            },
            {
                "contentTypeCode": "YUP",
                "format": "original",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "\"Before we had this water near our village, we had to walk far away and it was time taking and challenging .Now, we have more time to playing and studying.\" Says Chaltu, 13years old.",
                "url": "https://d3cfrqjucqh0ip.cloudfront.net/project/images/185551_20160908_161246_YUP.JPG",
                "lastModifiedDate": "2017-01-06T19:55:09",
                "mediaDate": "2016-09-08T16:12:46"
            },
            {
                "contentTypeCode": "YUP",
                "format": "web",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "\"Before we had this water near our village, we had to walk far away and it was time taking and challenging .Now, we have more time to playing and studying.\" Says Chaltu, 13years old.",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20160908_161246_YUP.JPG",
                "lastModifiedDate": "2017-01-06T19:55:09",
                "mediaDate": "2016-09-08T16:12:46"
            },
            {
                "contentTypeCode": "YUP",
                "format": "thumb",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "\"Before we had this water near our village, we had to walk far away and it was time taking and challenging .Now, we have more time to playing and studying.\" Says Chaltu, 13years old.",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20160908_161246_YUP_thumb.jpg",
                "lastModifiedDate": "2017-01-06T19:55:09",
                "mediaDate": "2016-09-08T16:12:46"
            },
            {
                "contentTypeCode": "YUP",
                "format": "original",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "Thanks to WV in giving training for our teachers and fulfilling the necessary materials would enable us to learn different learning methodology like 1 to 5 sitting arrangement which gives a chance to every student to express his or feelings. \"says,Mimi , 11.",
                "url": "https://d3cfrqjucqh0ip.cloudfront.net/project/images/185551_20160906_234139_YUP.JPG",
                "lastModifiedDate": "2017-01-06T19:55:09",
                "mediaDate": "2016-09-06T23:41:39"
            },
            {
                "contentTypeCode": "YUP",
                "format": "web",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "Thanks to WV in giving training for our teachers and fulfilling the necessary materials would enable us to learn different learning methodology like 1 to 5 sitting arrangement which gives a chance to every student to express his or feelings. \"says,Mimi , 11.",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20160906_234139_YUP.JPG",
                "lastModifiedDate": "2017-01-06T19:55:09",
                "mediaDate": "2016-09-06T23:41:39"
            },
            {
                "contentTypeCode": "YUP",
                "format": "thumb",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "Thanks to WV in giving training for our teachers and fulfilling the necessary materials would enable us to learn different learning methodology like 1 to 5 sitting arrangement which gives a chance to every student to express his or feelings. \"says,Mimi , 11.",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20160906_234139_YUP_thumb.jpg",
                "lastModifiedDate": "2017-01-06T19:55:09",
                "mediaDate": "2016-09-06T23:41:39"
            },
            {
                "contentTypeCode": "YUP",
                "format": "original",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "The demonstration of child right  in the form of drama like  on Africa child day  helps to create awareness for every child about child right .Now, me and my friends understand that how to exercise our right as well as protect ourselves from any kinds of child abuse .\" says, Milikias, 12.",
                "url": "https://d3cfrqjucqh0ip.cloudfront.net/project/images/185551_20160906_234135_YUP.JPG",
                "lastModifiedDate": "2017-01-06T19:55:09",
                "mediaDate": "2016-09-06T23:41:35"
            },
            {
                "contentTypeCode": "YUP",
                "format": "web",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "The demonstration of child right  in the form of drama like  on Africa child day  helps to create awareness for every child about child right .Now, me and my friends understand that how to exercise our right as well as protect ourselves from any kinds of child abuse .\" says, Milikias, 12.",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20160906_234135_YUP.JPG",
                "lastModifiedDate": "2017-01-06T19:55:09",
                "mediaDate": "2016-09-06T23:41:35"
            },
            {
                "contentTypeCode": "YUP",
                "format": "thumb",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "The demonstration of child right  in the form of drama like  on Africa child day  helps to create awareness for every child about child right .Now, me and my friends understand that how to exercise our right as well as protect ourselves from any kinds of child abuse .\" says, Milikias, 12.",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20160906_234135_YUP_thumb.jpg",
                "lastModifiedDate": "2017-01-06T19:55:09",
                "mediaDate": "2016-09-06T23:41:35"
            },
            {
                "contentTypeCode": "YUP",
                "format": "original",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "\"We are creating different types of teaching aid materials after our teachers have got literacy boost teacher training. Now, we have got an opportunity to learn more of practical things which highly improve our skills of creativity. \"says ,Tekalign,12.",
                "url": "https://d3cfrqjucqh0ip.cloudfront.net/project/images/185551_20160906_234121_YUP.JPG",
                "lastModifiedDate": "2017-01-06T19:55:09",
                "mediaDate": "2016-09-06T23:41:21"
            },
            {
                "contentTypeCode": "YUP",
                "format": "web",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "\"We are creating different types of teaching aid materials after our teachers have got literacy boost teacher training. Now, we have got an opportunity to learn more of practical things which highly improve our skills of creativity. \"says ,Tekalign,12.",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20160906_234121_YUP.JPG",
                "lastModifiedDate": "2017-01-06T19:55:09",
                "mediaDate": "2016-09-06T23:41:21"
            },
            {
                "contentTypeCode": "YUP",
                "format": "thumb",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "\"We are creating different types of teaching aid materials after our teachers have got literacy boost teacher training. Now, we have got an opportunity to learn more of practical things which highly improve our skills of creativity. \"says ,Tekalign,12.",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20160906_234121_YUP_thumb.jpg",
                "lastModifiedDate": "2017-01-06T19:55:09",
                "mediaDate": "2016-09-06T23:41:21"
            },
            {
                "contentTypeCode": "YUP",
                "format": "original",
                "subtypeCode": "ST048",
                "subtypeDescription": "APR",
                "captionForSupporter": "\"I like learning and having fun at preschool because we have a playground now.\" – Mamush, 6 years old",
                "url": "https://d3cfrqjucqh0ip.cloudfront.net/project/images/185551_20170209_134249_YUP.JPG",
                "lastModifiedDate": "2017-10-06T18:27:18",
                "mediaDate": "2017-02-09T13:42:49"
            },
            {
                "contentTypeCode": "YUP",
                "format": "web",
                "subtypeCode": "ST048",
                "subtypeDescription": "APR",
                "captionForSupporter": "\"I like learning and having fun at preschool because we have a playground now.\" – Mamush, 6 years old",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20170209_134249_YUP.JPG",
                "lastModifiedDate": "2017-10-06T18:27:18",
                "mediaDate": "2017-02-09T13:42:49"
            },
            {
                "contentTypeCode": "YUP",
                "format": "thumb",
                "subtypeCode": "ST048",
                "subtypeDescription": "APR",
                "captionForSupporter": "\"I like learning and having fun at preschool because we have a playground now.\" – Mamush, 6 years old",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20170209_134249_YUP_thumb.jpg",
                "lastModifiedDate": "2017-10-06T18:27:18",
                "mediaDate": "2017-02-09T13:42:49"
            },
            {
                "contentTypeCode": "YUP",
                "format": "original",
                "subtypeCode": "ST048",
                "subtypeDescription": "APR",
                "captionForSupporter": "\"Since our teachers attended training, we have more opportunities to do creative projects at school.\" – Tekalign, 12 years old (right)",
                "url": "https://d3cfrqjucqh0ip.cloudfront.net/project/images/185551_20170209_134246_YUP.JPG",
                "lastModifiedDate": "2017-10-06T18:27:18",
                "mediaDate": "2017-02-09T13:42:46"
            },
            {
                "contentTypeCode": "YUP",
                "format": "web",
                "subtypeCode": "ST048",
                "subtypeDescription": "APR",
                "captionForSupporter": "\"Since our teachers attended training, we have more opportunities to do creative projects at school.\" – Tekalign, 12 years old (right)",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20170209_134246_YUP.JPG",
                "lastModifiedDate": "2017-10-06T18:27:18",
                "mediaDate": "2017-02-09T13:42:46"
            },
            {
                "contentTypeCode": "YUP",
                "format": "thumb",
                "subtypeCode": "ST048",
                "subtypeDescription": "APR",
                "captionForSupporter": "\"Since our teachers attended training, we have more opportunities to do creative projects at school.\" – Tekalign, 12 years old (right)",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20170209_134246_YUP_thumb.jpg",
                "lastModifiedDate": "2017-10-06T18:27:18",
                "mediaDate": "2017-02-09T13:42:46"
            },
            {
                "contentTypeCode": "YUP",
                "format": "original",
                "subtypeCode": "ST048",
                "subtypeDescription": "APR",
                "captionForSupporter": "\"Chickens provide fresh eggs and bring in extra income for my family. My children will grow up strong and healthy because they now eat nutritious meals.\" – Elefe, mother (far right)",
                "url": "https://d3cfrqjucqh0ip.cloudfront.net/project/images/185551_20170209_134242_YUP.JPG",
                "lastModifiedDate": "2017-10-06T18:40:40",
                "mediaDate": "2017-02-09T13:42:42"
            },
            {
                "contentTypeCode": "YUP",
                "format": "web",
                "subtypeCode": "ST048",
                "subtypeDescription": "APR",
                "captionForSupporter": "\"Chickens provide fresh eggs and bring in extra income for my family. My children will grow up strong and healthy because they now eat nutritious meals.\" – Elefe, mother (far right)",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20170209_134242_YUP.JPG",
                "lastModifiedDate": "2017-10-06T18:40:40",
                "mediaDate": "2017-02-09T13:42:42"
            },
            {
                "contentTypeCode": "YUP",
                "format": "thumb",
                "subtypeCode": "ST048",
                "subtypeDescription": "APR",
                "captionForSupporter": "\"Chickens provide fresh eggs and bring in extra income for my family. My children will grow up strong and healthy because they now eat nutritious meals.\" – Elefe, mother (far right)",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20170209_134242_YUP_thumb.jpg",
                "lastModifiedDate": "2017-10-06T18:40:40",
                "mediaDate": "2017-02-09T13:42:42"
            },
            {
                "contentTypeCode": "YUP",
                "format": "original",
                "subtypeCode": "ST048",
                "subtypeDescription": "APR",
                "captionForSupporter": "\"I learned how to grow vegetables and received seeds to get me started. Growing chili peppers helps me earn enough money to meet my family’s needs.\" – Guyo, father (middle)",
                "url": "https://d3cfrqjucqh0ip.cloudfront.net/project/images/185551_20170209_134238_YUP.JPG",
                "lastModifiedDate": "2017-10-06T18:27:18",
                "mediaDate": "2017-02-09T13:42:38"
            },
            {
                "contentTypeCode": "YUP",
                "format": "web",
                "subtypeCode": "ST048",
                "subtypeDescription": "APR",
                "captionForSupporter": "\"I learned how to grow vegetables and received seeds to get me started. Growing chili peppers helps me earn enough money to meet my family’s needs.\" – Guyo, father (middle)",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20170209_134238_YUP.JPG",
                "lastModifiedDate": "2017-10-06T18:27:18",
                "mediaDate": "2017-02-09T13:42:38"
            },
            {
                "contentTypeCode": "YUP",
                "format": "thumb",
                "subtypeCode": "ST048",
                "subtypeDescription": "APR",
                "captionForSupporter": "\"I learned how to grow vegetables and received seeds to get me started. Growing chili peppers helps me earn enough money to meet my family’s needs.\" – Guyo, father (middle)",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20170209_134238_YUP_thumb.jpg",
                "lastModifiedDate": "2017-10-06T18:27:18",
                "mediaDate": "2017-02-09T13:42:38"
            },
            {
                "contentTypeCode": "YUP",
                "format": "original",
                "subtypeCode": "ST048",
                "subtypeDescription": "APR",
                "captionForSupporter": "\"World Vision trained pregnant women and community leaders on maternal and newborn care. Now, more pregnant women have antenatal visits and skilled midwives during delivery.\" Geleglo, health center midwife",
                "url": "https://d3cfrqjucqh0ip.cloudfront.net/project/images/185551_20160916_161259_YUP.JPG",
                "lastModifiedDate": "2017-02-06T21:51:24",
                "mediaDate": "2016-09-16T16:12:59"
            },
            {
                "contentTypeCode": "YUP",
                "format": "web",
                "subtypeCode": "ST048",
                "subtypeDescription": "APR",
                "captionForSupporter": "\"World Vision trained pregnant women and community leaders on maternal and newborn care. Now, more pregnant women have antenatal visits and skilled midwives during delivery.\" Geleglo, health center midwife",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20160916_161259_YUP.JPG",
                "lastModifiedDate": "2017-02-06T21:51:24",
                "mediaDate": "2016-09-16T16:12:59"
            },
            {
                "contentTypeCode": "YUP",
                "format": "thumb",
                "subtypeCode": "ST048",
                "subtypeDescription": "APR",
                "captionForSupporter": "\"World Vision trained pregnant women and community leaders on maternal and newborn care. Now, more pregnant women have antenatal visits and skilled midwives during delivery.\" Geleglo, health center midwife",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20160916_161259_YUP_thumb.jpg",
                "lastModifiedDate": "2017-02-06T21:51:24",
                "mediaDate": "2016-09-16T16:12:59"
            },
            {
                "contentTypeCode": "YUP",
                "format": "original",
                "subtypeCode": "ST048",
                "subtypeDescription": "APR",
                "captionForSupporter": "\"We used to travel 40 minutes to fetch water. Our children suffered from waterborne diseases. Now we have clean water and our children are healthier.\" Tadelech, water committee member",
                "url": "https://d3cfrqjucqh0ip.cloudfront.net/project/images/185551_20160208_194331_YUP.JPG",
                "lastModifiedDate": "2017-02-06T21:51:24",
                "mediaDate": "2016-02-08T19:43:31"
            },
            {
                "contentTypeCode": "YUP",
                "format": "web",
                "subtypeCode": "ST048",
                "subtypeDescription": "APR",
                "captionForSupporter": "\"We used to travel 40 minutes to fetch water. Our children suffered from waterborne diseases. Now we have clean water and our children are healthier.\" Tadelech, water committee member",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20160208_194331_YUP.JPG",
                "lastModifiedDate": "2017-02-06T21:51:24",
                "mediaDate": "2016-02-08T19:43:31"
            },
            {
                "contentTypeCode": "YUP",
                "format": "thumb",
                "subtypeCode": "ST048",
                "subtypeDescription": "APR",
                "captionForSupporter": "\"We used to travel 40 minutes to fetch water. Our children suffered from waterborne diseases. Now we have clean water and our children are healthier.\" Tadelech, water committee member",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20160208_194331_YUP_thumb.jpg",
                "lastModifiedDate": "2017-02-06T21:51:24",
                "mediaDate": "2016-02-08T19:43:31"
            },
            {
                "contentTypeCode": "YUP",
                "format": "original",
                "subtypeCode": "ST048",
                "subtypeDescription": "APR",
                "captionForSupporter": "\"World Vision reading camps have different types of reading books. I attend reading classes and improve my reading. I am first in class.\" Murtessa, 11 years old",
                "url": "https://d3cfrqjucqh0ip.cloudfront.net/project/images/185551_20160208_194341_YUP.JPG",
                "lastModifiedDate": "2017-02-06T21:51:24",
                "mediaDate": "0001-01-01T00:00:00"
            },
            {
                "contentTypeCode": "YUP",
                "format": "web",
                "subtypeCode": "ST048",
                "subtypeDescription": "APR",
                "captionForSupporter": "\"World Vision reading camps have different types of reading books. I attend reading classes and improve my reading. I am first in class.\" Murtessa, 11 years old",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20160208_194341_YUP.JPG",
                "lastModifiedDate": "2017-02-06T21:51:24",
                "mediaDate": "0001-01-01T00:00:00"
            },
            {
                "contentTypeCode": "YUP",
                "format": "thumb",
                "subtypeCode": "ST048",
                "subtypeDescription": "APR",
                "captionForSupporter": "\"World Vision reading camps have different types of reading books. I attend reading classes and improve my reading. I am first in class.\" Murtessa, 11 years old",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20160208_194341_YUP_thumb.jpg",
                "lastModifiedDate": "2017-02-06T21:51:24",
                "mediaDate": "0001-01-01T00:00:00"
            },
            {
                "contentTypeCode": "YUV",
                "format": "vthumb",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "Take a look at the exciting progress being made in your sponsored child's community thanks to your donations over the last year.",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20180910_105909_YUV_vThumb.png",
                "lastModifiedDate": "2018-09-21T22:21:49",
                "mediaDate": "2018-09-10T10:59:09"
            },
            {
                "contentTypeCode": "YUV",
                "format": "ipad",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "Take a look at the exciting progress being made in your sponsored child's community thanks to your donations over the last year.",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/video/185551_20180910_105909_YUV_iPad.mp4",
                "lastModifiedDate": "2018-09-21T22:21:49",
                "mediaDate": "2018-09-10T10:59:09"
            },
            {
                "contentTypeCode": "YUV",
                "format": "mob",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "Take a look at the exciting progress being made in your sponsored child's community thanks to your donations over the last year.",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/video/185551_20180910_105909_YUV_Mob.mp4",
                "lastModifiedDate": "2018-09-21T22:21:49",
                "mediaDate": "2018-09-10T10:59:09"
            },
            {
                "contentTypeCode": "YUV",
                "format": "web",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "Take a look at the exciting progress being made in your sponsored child's community thanks to your donations over the last year.",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/video/185551_20180910_105909_YUV_Web.mp4",
                "lastModifiedDate": "2018-09-21T22:21:49",
                "mediaDate": "2018-09-10T10:59:09"
            },
            {
                "contentTypeCode": "YUV",
                "format": "vthumb",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "Take a look at the exciting progress being made in your sponsored child's community thanks to your donations over the last year.",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20171127_071622_YUV_vThumb.png",
                "lastModifiedDate": "2017-11-27T18:26:59",
                "mediaDate": "2017-11-27T07:16:22"
            },
            {
                "contentTypeCode": "YUV",
                "format": "ipad",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "Take a look at the exciting progress being made in your sponsored child's community thanks to your donations over the last year.",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/video/185551_20171127_071622_YUV_iPad.mp4",
                "lastModifiedDate": "2017-11-27T18:26:59",
                "mediaDate": "2017-11-27T07:16:22"
            },
            {
                "contentTypeCode": "YUV",
                "format": "mob",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "Take a look at the exciting progress being made in your sponsored child's community thanks to your donations over the last year.",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/video/185551_20171127_071622_YUV_Mob.mp4",
                "lastModifiedDate": "2017-11-27T18:26:59",
                "mediaDate": "2017-11-27T07:16:22"
            },
            {
                "contentTypeCode": "YUV",
                "format": "web",
                "subtypeCode": "ST001",
                "subtypeDescription": "Annual",
                "captionForSupporter": "Take a look at the exciting progress being made in your sponsored child's community thanks to your donations over the last year.",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/video/185551_20171127_071622_YUV_Web.mp4",
                "lastModifiedDate": "2017-11-27T18:26:59",
                "mediaDate": "2017-11-27T07:16:22"
            },
            {
                "contentTypeCode": "YUV",
                "format": "vthumb",
                "subtypeCode": "ST002",
                "subtypeDescription": "Children's Special Moments",
                "captionForSupporter": "Children in collaboration with Abaya ADP have organized a get together for themselves on April 30, 2017 with the objective of children enjoying freedom, respect, well-being, simply playing and having fun with their friends, this shows that they are active members of the community. ",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20170711_142356_YUV_vThumb.png",
                "lastModifiedDate": "2017-08-04T17:35:41",
                "mediaDate": "2017-07-11T14:23:56"
            },
            {
                "contentTypeCode": "YUV",
                "format": "ipad",
                "subtypeCode": "ST002",
                "subtypeDescription": "Children's Special Moments",
                "captionForSupporter": "Children in collaboration with Abaya ADP have organized a get together for themselves on April 30, 2017 with the objective of children enjoying freedom, respect, well-being, simply playing and having fun with their friends, this shows that they are active members of the community. ",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/video/185551_20170711_142356_YUV_iPad.mp4",
                "lastModifiedDate": "2017-08-04T17:35:41",
                "mediaDate": "2017-07-11T14:23:56"
            },
            {
                "contentTypeCode": "YUV",
                "format": "mob",
                "subtypeCode": "ST002",
                "subtypeDescription": "Children's Special Moments",
                "captionForSupporter": "Children in collaboration with Abaya ADP have organized a get together for themselves on April 30, 2017 with the objective of children enjoying freedom, respect, well-being, simply playing and having fun with their friends, this shows that they are active members of the community. ",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/video/185551_20170711_142356_YUV_Mob.mp4",
                "lastModifiedDate": "2017-08-04T17:35:41",
                "mediaDate": "2017-07-11T14:23:56"
            },
            {
                "contentTypeCode": "YUV",
                "format": "web",
                "subtypeCode": "ST002",
                "subtypeDescription": "Children's Special Moments",
                "captionForSupporter": "Children in collaboration with Abaya ADP have organized a get together for themselves on April 30, 2017 with the objective of children enjoying freedom, respect, well-being, simply playing and having fun with their friends, this shows that they are active members of the community. ",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/video/185551_20170711_142356_YUV_Web.mp4",
                "lastModifiedDate": "2017-08-04T17:35:41",
                "mediaDate": "2017-07-11T14:23:56"
            },
            {
                "contentTypeCode": "YUV",
                "format": "vthumb",
                "subtypeCode": "ST002",
                "subtypeDescription": "Children's Special Moments",
                "captionForSupporter": "Children in collaboration with Abaya ADP have organized a get together for themselves on April 30, 2017 with the objective of children enjoying freedom, respect, well-being, simply playing and having fun with their friends, this shows that they are active members of the community. ",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20170711_142327_YUV_vThumb.png",
                "lastModifiedDate": "2017-08-04T17:35:41",
                "mediaDate": "2017-07-11T14:23:27"
            },
            {
                "contentTypeCode": "YUV",
                "format": "ipad",
                "subtypeCode": "ST002",
                "subtypeDescription": "Children's Special Moments",
                "captionForSupporter": "Children in collaboration with Abaya ADP have organized a get together for themselves on April 30, 2017 with the objective of children enjoying freedom, respect, well-being, simply playing and having fun with their friends, this shows that they are active members of the community. ",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/video/185551_20170711_142327_YUV_iPad.mp4",
                "lastModifiedDate": "2017-08-04T17:35:41",
                "mediaDate": "2017-07-11T14:23:27"
            },
            {
                "contentTypeCode": "YUV",
                "format": "mob",
                "subtypeCode": "ST002",
                "subtypeDescription": "Children's Special Moments",
                "captionForSupporter": "Children in collaboration with Abaya ADP have organized a get together for themselves on April 30, 2017 with the objective of children enjoying freedom, respect, well-being, simply playing and having fun with their friends, this shows that they are active members of the community. ",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/video/185551_20170711_142327_YUV_Mob.mp4",
                "lastModifiedDate": "2017-08-04T17:35:41",
                "mediaDate": "2017-07-11T14:23:27"
            },
            {
                "contentTypeCode": "YUV",
                "format": "web",
                "subtypeCode": "ST002",
                "subtypeDescription": "Children's Special Moments",
                "captionForSupporter": "Children in collaboration with Abaya ADP have organized a get together for themselves on April 30, 2017 with the objective of children enjoying freedom, respect, well-being, simply playing and having fun with their friends, this shows that they are active members of the community. ",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/video/185551_20170711_142327_YUV_Web.mp4",
                "lastModifiedDate": "2017-08-04T17:35:41",
                "mediaDate": "2017-07-11T14:23:27"
            },
            {
                "contentTypeCode": "YUV",
                "format": "vthumb",
                "subtypeCode": "ST002",
                "subtypeDescription": "Children's Special Moments",
                "captionForSupporter": "Children in collaboration with Abaya ADP have organized a get together for themselves on April 30, 2017 with the objective of children enjoying freedom, respect, well-being, simply playing and having fun with their friends, this shows that they are active members of the community. ",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20170711_142307_YUV_vThumb.png",
                "lastModifiedDate": "2017-08-04T17:35:41",
                "mediaDate": "2017-07-11T14:23:07"
            },
            {
                "contentTypeCode": "YUV",
                "format": "ipad",
                "subtypeCode": "ST002",
                "subtypeDescription": "Children's Special Moments",
                "captionForSupporter": "Children in collaboration with Abaya ADP have organized a get together for themselves on April 30, 2017 with the objective of children enjoying freedom, respect, well-being, simply playing and having fun with their friends, this shows that they are active members of the community. ",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/video/185551_20170711_142307_YUV_iPad.mp4",
                "lastModifiedDate": "2017-08-04T17:35:41",
                "mediaDate": "2017-07-11T14:23:07"
            },
            {
                "contentTypeCode": "YUV",
                "format": "mob",
                "subtypeCode": "ST002",
                "subtypeDescription": "Children's Special Moments",
                "captionForSupporter": "Children in collaboration with Abaya ADP have organized a get together for themselves on April 30, 2017 with the objective of children enjoying freedom, respect, well-being, simply playing and having fun with their friends, this shows that they are active members of the community. ",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/video/185551_20170711_142307_YUV_Mob.mp4",
                "lastModifiedDate": "2017-08-04T17:35:41",
                "mediaDate": "2017-07-11T14:23:07"
            },
            {
                "contentTypeCode": "YUV",
                "format": "web",
                "subtypeCode": "ST002",
                "subtypeDescription": "Children's Special Moments",
                "captionForSupporter": "Children in collaboration with Abaya ADP have organized a get together for themselves on April 30, 2017 with the objective of children enjoying freedom, respect, well-being, simply playing and having fun with their friends, this shows that they are active members of the community. ",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/video/185551_20170711_142307_YUV_Web.mp4",
                "lastModifiedDate": "2017-08-04T17:35:41",
                "mediaDate": "2017-07-11T14:23:07"
            },
            {
                "contentTypeCode": "YUV",
                "format": "vthumb",
                "subtypeCode": "ST002",
                "subtypeDescription": "Children's Special Moments",
                "captionForSupporter": "Millikyas , Tesfaye & Mirhet  are also children who are actively participate in the child pare aliment .. They confirmed that children in their village are faced different problems in their community as well as in their family from their relatives and family members .They are trying to transmit thei",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20160913_135904_YUV_vThumb.png",
                "lastModifiedDate": "2017-01-30T21:31:55",
                "mediaDate": "2016-09-13T13:59:04"
            },
            {
                "contentTypeCode": "YUV",
                "format": "ipad",
                "subtypeCode": "ST002",
                "subtypeDescription": "Children's Special Moments",
                "captionForSupporter": "Millikyas , Tesfaye & Mirhet  are also children who are actively participate in the child pare aliment .. They confirmed that children in their village are faced different problems in their community as well as in their family from their relatives and family members .They are trying to transmit thei",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/video/185551_20160913_135904_YUV_iPad.mp4",
                "lastModifiedDate": "2017-01-30T21:31:55",
                "mediaDate": "2016-09-13T13:59:04"
            },
            {
                "contentTypeCode": "YUV",
                "format": "mob",
                "subtypeCode": "ST002",
                "subtypeDescription": "Children's Special Moments",
                "captionForSupporter": "Millikyas , Tesfaye & Mirhet  are also children who are actively participate in the child pare aliment .. They confirmed that children in their village are faced different problems in their community as well as in their family from their relatives and family members .They are trying to transmit thei",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/video/185551_20160913_135904_YUV_Mob.mp4",
                "lastModifiedDate": "2017-01-30T21:31:55",
                "mediaDate": "2016-09-13T13:59:04"
            },
            {
                "contentTypeCode": "YUV",
                "format": "web",
                "subtypeCode": "ST002",
                "subtypeDescription": "Children's Special Moments",
                "captionForSupporter": "Millikyas , Tesfaye & Mirhet  are also children who are actively participate in the child pare aliment .. They confirmed that children in their village are faced different problems in their community as well as in their family from their relatives and family members .They are trying to transmit thei",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/video/185551_20160913_135904_YUV_Web.mp4",
                "lastModifiedDate": "2017-01-30T21:31:55",
                "mediaDate": "2016-09-13T13:59:04"
            },
            {
                "contentTypeCode": "YUV",
                "format": "vthumb",
                "subtypeCode": "ST002",
                "subtypeDescription": "Children's Special Moments",
                "captionForSupporter": "Fisum Tesfaye a 14-year child in Abaya area is one of the children who are using child centre and a member of sport club. Today he and other members of the community children are playing volleyball. ",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20151006_095705_YUV_vThumb.png",
                "lastModifiedDate": "2016-01-15T03:04:15",
                "mediaDate": "2015-10-06T09:57:05"
            },
            {
                "contentTypeCode": "YUV",
                "format": "ipad",
                "subtypeCode": "ST002",
                "subtypeDescription": "Children's Special Moments",
                "captionForSupporter": "Fisum Tesfaye a 14-year child in Abaya area is one of the children who are using child centre and a member of sport club. Today he and other members of the community children are playing volleyball. ",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/video/185551_20151006_095705_YUV_iPad.mp4",
                "lastModifiedDate": "2016-01-15T03:04:15",
                "mediaDate": "2015-10-06T09:57:05"
            },
            {
                "contentTypeCode": "YUV",
                "format": "mob",
                "subtypeCode": "ST002",
                "subtypeDescription": "Children's Special Moments",
                "captionForSupporter": "Fisum Tesfaye a 14-year child in Abaya area is one of the children who are using child centre and a member of sport club. Today he and other members of the community children are playing volleyball. ",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/video/185551_20151006_095705_YUV_Mob.mp4",
                "lastModifiedDate": "2016-01-15T03:04:15",
                "mediaDate": "2015-10-06T09:57:05"
            },
            {
                "contentTypeCode": "YUV",
                "format": "web",
                "subtypeCode": "ST002",
                "subtypeDescription": "Children's Special Moments",
                "captionForSupporter": "Fisum Tesfaye a 14-year child in Abaya area is one of the children who are using child centre and a member of sport club. Today he and other members of the community children are playing volleyball. ",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/video/185551_20151006_095705_YUV_Web.mp4",
                "lastModifiedDate": "2016-01-15T03:04:15",
                "mediaDate": "2015-10-06T09:57:05"
            },
            {
                "contentTypeCode": "YUV",
                "format": "vthumb",
                "subtypeCode": "ST002",
                "subtypeDescription": "Children's Special Moments",
                "captionForSupporter": "Children of Abaya ADP (sport club) has requested the ADP to learn about the child protection while they are in the playing activity & Ethiopia (name of a staff), is one of WV staff at Abaya ADP, she advising children by thinking that Nurture the leaders of tomorrow.",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/images/185551_20151006_095651_YUV_vThumb.png",
                "lastModifiedDate": "2016-01-15T03:04:15",
                "mediaDate": "2015-10-06T09:56:51"
            },
            {
                "contentTypeCode": "YUV",
                "format": "ipad",
                "subtypeCode": "ST002",
                "subtypeDescription": "Children's Special Moments",
                "captionForSupporter": "Children of Abaya ADP (sport club) has requested the ADP to learn about the child protection while they are in the playing activity & Ethiopia (name of a staff), is one of WV staff at Abaya ADP, she advising children by thinking that Nurture the leaders of tomorrow.",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/video/185551_20151006_095651_YUV_iPad.mp4",
                "lastModifiedDate": "2016-01-15T03:04:15",
                "mediaDate": "2015-10-06T09:56:51"
            },
            {
                "contentTypeCode": "YUV",
                "format": "mob",
                "subtypeCode": "ST002",
                "subtypeDescription": "Children's Special Moments",
                "captionForSupporter": "Children of Abaya ADP (sport club) has requested the ADP to learn about the child protection while they are in the playing activity & Ethiopia (name of a staff), is one of WV staff at Abaya ADP, she advising children by thinking that Nurture the leaders of tomorrow.",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/video/185551_20151006_095651_YUV_Mob.mp4",
                "lastModifiedDate": "2016-01-15T03:04:15",
                "mediaDate": "2015-10-06T09:56:51"
            },
            {
                "contentTypeCode": "YUV",
                "format": "web",
                "subtypeCode": "ST002",
                "subtypeDescription": "Children's Special Moments",
                "captionForSupporter": "Children of Abaya ADP (sport club) has requested the ADP to learn about the child protection while they are in the playing activity & Ethiopia (name of a staff), is one of WV staff at Abaya ADP, she advising children by thinking that Nurture the leaders of tomorrow.",
                "url": "https://d4j0oemdjsbb4.cloudfront.net/project/video/185551_20151006_095651_YUV_Web.mp4",
                "lastModifiedDate": "2016-01-15T03:04:15",
                "mediaDate": "2015-10-06T09:56:51"
            }
        ]
    },
    "success": true,
    "code": 200,
    "message": "The child for identifier 015d5bd7-b63b-4870-ba3c-c573950c9af2 was retrieved."
}


*/
